import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigFloat: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Cursor: { input: any; output: any; }
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type Address = Node & {
  __typename?: 'Address';
  countryByCountryId?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['BigInt']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  nodeId: Scalars['ID']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

export type AddressCondition = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AddressFilter = {
  and?: InputMaybe<Array<AddressFilter>>;
  countryByCountryId?: InputMaybe<CountryFilter>;
  countryByCountryIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  line1?: InputMaybe<StringFilter>;
  line2?: InputMaybe<StringFilter>;
  not?: InputMaybe<AddressFilter>;
  or?: InputMaybe<Array<AddressFilter>>;
  postcode?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  suburb?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type AddressInput = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AddressPatch = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AddressesConnection = {
  __typename?: 'AddressesConnection';
  edges: Array<AddressesEdge>;
  nodes: Array<Maybe<Address>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AddressesEdge = {
  __typename?: 'AddressesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<Address>;
};

export enum AddressesOrderBy {
  CountryIdAsc = 'COUNTRY_ID_ASC',
  CountryIdDesc = 'COUNTRY_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Line_1Asc = 'LINE_1_ASC',
  Line_1Desc = 'LINE_1_DESC',
  Line_2Asc = 'LINE_2_ASC',
  Line_2Desc = 'LINE_2_DESC',
  Natural = 'NATURAL',
  PostcodeAsc = 'POSTCODE_ASC',
  PostcodeDesc = 'POSTCODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  SuburbAsc = 'SUBURB_ASC',
  SuburbDesc = 'SUBURB_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Agent = Node & {
  __typename?: 'Agent';
  abn?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  bookingsByAgentId: BookingsConnection;
  countryByCountryId?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  email?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};


export type AgentBookingsByAgentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BookingCondition>;
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};

export type AgentCondition = {
  abn?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AgentFilter = {
  abn?: InputMaybe<StringFilter>;
  address?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<AgentFilter>>;
  bookingsByAgentId?: InputMaybe<AgentToManyBookingFilter>;
  bookingsByAgentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  countryByCountryId?: InputMaybe<CountryFilter>;
  countryByCountryIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringListFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<AgentFilter>;
  or?: InputMaybe<Array<AgentFilter>>;
  phone?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type AgentInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AgentPatch = {
  abn?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type AgentToManyBookingFilter = {
  every?: InputMaybe<BookingFilter>;
  none?: InputMaybe<BookingFilter>;
  some?: InputMaybe<BookingFilter>;
};

export type AgentsConnection = {
  __typename?: 'AgentsConnection';
  edges: Array<AgentsEdge>;
  nodes: Array<Maybe<Agent>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgentsEdge = {
  __typename?: 'AgentsEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<Agent>;
};

export enum AgentsOrderBy {
  AbnAsc = 'ABN_ASC',
  AbnDesc = 'ABN_DESC',
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  CountryIdAsc = 'COUNTRY_ID_ASC',
  CountryIdDesc = 'COUNTRY_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type BigFloatFilter = {
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

export type BigIntFilter = {
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type Booking = Node & {
  __typename?: 'Booking';
  agentByAgentId?: Maybe<Agent>;
  agentId: Scalars['Int']['output'];
  bookingPricesByBookingId: BookingPricesConnection;
  createdAt: Scalars['Datetime']['output'];
  currency: Scalars['String']['output'];
  dischargePort?: Maybe<Scalars['Int']['output']>;
  etd?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  nodeId: Scalars['ID']['output'];
  pod?: Maybe<Scalars['Int']['output']>;
  pol?: Maybe<Scalars['Int']['output']>;
  portByDischargePort?: Maybe<Port>;
  portByPod?: Maybe<Port>;
  portByPol?: Maybe<Port>;
  remark?: Maybe<Scalars['String']['output']>;
  routeByRouteId?: Maybe<Route>;
  routeId?: Maybe<Scalars['Int']['output']>;
  routeVesselByRouteVesselId?: Maybe<RouteVessel>;
  routeVesselId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};


export type BookingBookingPricesByBookingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BookingPriceCondition>;
  filter?: InputMaybe<BookingPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BookingPricesOrderBy>>;
};

export type BookingCondition = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dischargePort?: InputMaybe<Scalars['Int']['input']>;
  etd?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pod?: InputMaybe<Scalars['Int']['input']>;
  pol?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  routeVesselId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BookingFilter = {
  agentByAgentId?: InputMaybe<AgentFilter>;
  agentId?: InputMaybe<IntFilter>;
  and?: InputMaybe<Array<BookingFilter>>;
  bookingPricesByBookingId?: InputMaybe<BookingToManyBookingPriceFilter>;
  bookingPricesByBookingIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<DatetimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dischargePort?: InputMaybe<IntFilter>;
  etd?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntFilter>;
  not?: InputMaybe<BookingFilter>;
  or?: InputMaybe<Array<BookingFilter>>;
  pod?: InputMaybe<IntFilter>;
  pol?: InputMaybe<IntFilter>;
  portByDischargePort?: InputMaybe<PortFilter>;
  portByDischargePortExists?: InputMaybe<Scalars['Boolean']['input']>;
  portByPod?: InputMaybe<PortFilter>;
  portByPodExists?: InputMaybe<Scalars['Boolean']['input']>;
  portByPol?: InputMaybe<PortFilter>;
  portByPolExists?: InputMaybe<Scalars['Boolean']['input']>;
  remark?: InputMaybe<StringFilter>;
  routeByRouteId?: InputMaybe<RouteFilter>;
  routeByRouteIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  routeId?: InputMaybe<IntFilter>;
  routeVesselByRouteVesselId?: InputMaybe<RouteVesselFilter>;
  routeVesselByRouteVesselIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  routeVesselId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type BookingInput = {
  agentId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dischargePort?: InputMaybe<Scalars['Int']['input']>;
  etd?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pod?: InputMaybe<Scalars['Int']['input']>;
  pol?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  routeVesselId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BookingPatch = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dischargePort?: InputMaybe<Scalars['Int']['input']>;
  etd?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pod?: InputMaybe<Scalars['Int']['input']>;
  pol?: InputMaybe<Scalars['Int']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  routeVesselId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BookingPrice = Node & {
  __typename?: 'BookingPrice';
  bookingByBookingId?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  containerSize?: Maybe<ContainerSizeEnum>;
  cost?: Maybe<Scalars['BigFloat']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  nodeId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type BookingPriceCondition = {
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  containerSize?: InputMaybe<ContainerSizeEnum>;
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BookingPriceFilter = {
  and?: InputMaybe<Array<BookingPriceFilter>>;
  bookingByBookingId?: InputMaybe<BookingFilter>;
  bookingByBookingIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  bookingId?: InputMaybe<IntFilter>;
  containerSize?: InputMaybe<ContainerSizeEnumFilter>;
  cost?: InputMaybe<BigFloatFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  not?: InputMaybe<BookingPriceFilter>;
  or?: InputMaybe<Array<BookingPriceFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type BookingPriceInput = {
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  containerSize?: InputMaybe<ContainerSizeEnum>;
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BookingPricePatch = {
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  containerSize?: InputMaybe<ContainerSizeEnum>;
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type BookingPricesConnection = {
  __typename?: 'BookingPricesConnection';
  edges: Array<BookingPricesEdge>;
  nodes: Array<Maybe<BookingPrice>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BookingPricesEdge = {
  __typename?: 'BookingPricesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<BookingPrice>;
};

export enum BookingPricesOrderBy {
  BookingIdAsc = 'BOOKING_ID_ASC',
  BookingIdDesc = 'BOOKING_ID_DESC',
  ContainerSizeAsc = 'CONTAINER_SIZE_ASC',
  ContainerSizeDesc = 'CONTAINER_SIZE_DESC',
  CostAsc = 'COST_ASC',
  CostDesc = 'COST_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type BookingToManyBookingPriceFilter = {
  every?: InputMaybe<BookingPriceFilter>;
  none?: InputMaybe<BookingPriceFilter>;
  some?: InputMaybe<BookingPriceFilter>;
};

export type BookingsConnection = {
  __typename?: 'BookingsConnection';
  edges: Array<BookingsEdge>;
  nodes: Array<Maybe<Booking>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BookingsEdge = {
  __typename?: 'BookingsEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<Booking>;
};

export enum BookingsOrderBy {
  AgentIdAsc = 'AGENT_ID_ASC',
  AgentIdDesc = 'AGENT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  DischargePortAsc = 'DISCHARGE_PORT_ASC',
  DischargePortDesc = 'DISCHARGE_PORT_DESC',
  EtdAsc = 'ETD_ASC',
  EtdDesc = 'ETD_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PodAsc = 'POD_ASC',
  PodDesc = 'POD_DESC',
  PolAsc = 'POL_ASC',
  PolDesc = 'POL_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RemarkAsc = 'REMARK_ASC',
  RemarkDesc = 'REMARK_DESC',
  RouteIdAsc = 'ROUTE_ID_ASC',
  RouteIdDesc = 'ROUTE_ID_DESC',
  RouteVesselIdAsc = 'ROUTE_VESSEL_ID_ASC',
  RouteVesselIdDesc = 'ROUTE_VESSEL_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum ContainerSizeEnum {
  Lcl = 'LCL',
  '20Ft' = '_20_FT',
  '40Ft' = '_40_FT',
  '40Nor' = '_40_NOR'
}

export type ContainerSizeEnumFilter = {
  distinctFrom?: InputMaybe<ContainerSizeEnum>;
  equalTo?: InputMaybe<ContainerSizeEnum>;
  greaterThan?: InputMaybe<ContainerSizeEnum>;
  greaterThanOrEqualTo?: InputMaybe<ContainerSizeEnum>;
  in?: InputMaybe<Array<ContainerSizeEnum>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<ContainerSizeEnum>;
  lessThanOrEqualTo?: InputMaybe<ContainerSizeEnum>;
  notDistinctFrom?: InputMaybe<ContainerSizeEnum>;
  notEqualTo?: InputMaybe<ContainerSizeEnum>;
  notIn?: InputMaybe<Array<ContainerSizeEnum>>;
};

export type CountriesConnection = {
  __typename?: 'CountriesConnection';
  edges: Array<CountriesEdge>;
  nodes: Array<Maybe<Country>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountriesEdge = {
  __typename?: 'CountriesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<Country>;
};

export enum CountriesOrderBy {
  CapitalAsc = 'CAPITAL_ASC',
  CapitalDesc = 'CAPITAL_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyCodeAsc = 'CURRENCY_CODE_ASC',
  CurrencyCodeDesc = 'CURRENCY_CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsoCode_2Asc = 'ISO_CODE_2_ASC',
  IsoCode_2Desc = 'ISO_CODE_2_DESC',
  IsoCode_3Asc = 'ISO_CODE_3_ASC',
  IsoCode_3Desc = 'ISO_CODE_3_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NumericCodeAsc = 'NUMERIC_CODE_ASC',
  NumericCodeDesc = 'NUMERIC_CODE_DESC',
  PhoneCodeAsc = 'PHONE_CODE_ASC',
  PhoneCodeDesc = 'PHONE_CODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC',
  SubregionAsc = 'SUBREGION_ASC',
  SubregionDesc = 'SUBREGION_DESC'
}

export type Country = Node & {
  __typename?: 'Country';
  addressesByCountryId: AddressesConnection;
  agentsByCountryId: AgentsConnection;
  capital?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isoCode2: Scalars['String']['output'];
  isoCode3: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  numericCode?: Maybe<Scalars['String']['output']>;
  phoneCode?: Maybe<Scalars['String']['output']>;
  portsByCountryId: PortsConnection;
  region?: Maybe<Scalars['String']['output']>;
  statesByCountryId: StatesConnection;
  subregion?: Maybe<Scalars['String']['output']>;
};


export type CountryAddressesByCountryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AddressCondition>;
  filter?: InputMaybe<AddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};


export type CountryAgentsByCountryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AgentCondition>;
  filter?: InputMaybe<AgentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AgentsOrderBy>>;
};


export type CountryPortsByCountryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCondition>;
  filter?: InputMaybe<PortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortsOrderBy>>;
};


export type CountryStatesByCountryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StateCondition>;
  filter?: InputMaybe<StateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatesOrderBy>>;
};

export type CountryCondition = {
  capital?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isoCode2?: InputMaybe<Scalars['String']['input']>;
  isoCode3?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numericCode?: InputMaybe<Scalars['String']['input']>;
  phoneCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<Scalars['String']['input']>;
};

export type CountryFilter = {
  addressesByCountryId?: InputMaybe<CountryToManyAddressFilter>;
  addressesByCountryIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  agentsByCountryId?: InputMaybe<CountryToManyAgentFilter>;
  agentsByCountryIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<CountryFilter>>;
  capital?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  currencyCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isoCode2?: InputMaybe<StringFilter>;
  isoCode3?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<CountryFilter>;
  numericCode?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<CountryFilter>>;
  phoneCode?: InputMaybe<StringFilter>;
  portsByCountryId?: InputMaybe<CountryToManyPortFilter>;
  portsByCountryIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<StringFilter>;
  statesByCountryId?: InputMaybe<CountryToManyStateFilter>;
  statesByCountryIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  subregion?: InputMaybe<StringFilter>;
};

export type CountryInput = {
  capital?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isoCode2: Scalars['String']['input'];
  isoCode3: Scalars['String']['input'];
  name: Scalars['String']['input'];
  numericCode?: InputMaybe<Scalars['String']['input']>;
  phoneCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<Scalars['String']['input']>;
};

export type CountryPatch = {
  capital?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isoCode2?: InputMaybe<Scalars['String']['input']>;
  isoCode3?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numericCode?: InputMaybe<Scalars['String']['input']>;
  phoneCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subregion?: InputMaybe<Scalars['String']['input']>;
};

export type CountryToManyAddressFilter = {
  every?: InputMaybe<AddressFilter>;
  none?: InputMaybe<AddressFilter>;
  some?: InputMaybe<AddressFilter>;
};

export type CountryToManyAgentFilter = {
  every?: InputMaybe<AgentFilter>;
  none?: InputMaybe<AgentFilter>;
  some?: InputMaybe<AgentFilter>;
};

export type CountryToManyPortFilter = {
  every?: InputMaybe<PortFilter>;
  none?: InputMaybe<PortFilter>;
  some?: InputMaybe<PortFilter>;
};

export type CountryToManyStateFilter = {
  every?: InputMaybe<StateFilter>;
  none?: InputMaybe<StateFilter>;
  some?: InputMaybe<StateFilter>;
};

export type CreateAddressInput = {
  address: AddressInput;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAddressPayload = {
  __typename?: 'CreateAddressPayload';
  address?: Maybe<Address>;
  addressEdge?: Maybe<AddressesEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  query?: Maybe<Query>;
};


export type CreateAddressPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};

export type CreateAgentInput = {
  agent: AgentInput;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAgentPayload = {
  __typename?: 'CreateAgentPayload';
  agent?: Maybe<Agent>;
  agentEdge?: Maybe<AgentsEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  query?: Maybe<Query>;
};


export type CreateAgentPayloadAgentEdgeArgs = {
  orderBy?: InputMaybe<Array<AgentsOrderBy>>;
};

export type CreateBookingInput = {
  booking: BookingInput;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBookingPayload = {
  __typename?: 'CreateBookingPayload';
  agentByAgentId?: Maybe<Agent>;
  booking?: Maybe<Booking>;
  bookingEdge?: Maybe<BookingsEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  portByDischargePort?: Maybe<Port>;
  portByPod?: Maybe<Port>;
  portByPol?: Maybe<Port>;
  query?: Maybe<Query>;
  routeByRouteId?: Maybe<Route>;
  routeVesselByRouteVesselId?: Maybe<RouteVessel>;
};


export type CreateBookingPayloadBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};

export type CreateBookingPriceInput = {
  bookingPrice: BookingPriceInput;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBookingPricePayload = {
  __typename?: 'CreateBookingPricePayload';
  bookingByBookingId?: Maybe<Booking>;
  bookingPrice?: Maybe<BookingPrice>;
  bookingPriceEdge?: Maybe<BookingPricesEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
};


export type CreateBookingPricePayloadBookingPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<BookingPricesOrderBy>>;
};

export type CreateCountryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  country: CountryInput;
};

export type CreateCountryPayload = {
  __typename?: 'CreateCountryPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryEdge?: Maybe<CountriesEdge>;
  query?: Maybe<Query>;
};


export type CreateCountryPayloadCountryEdgeArgs = {
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};

export type CreateFuelLevyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fuelLevy: FuelLevyInput;
};

export type CreateFuelLevyPayload = {
  __typename?: 'CreateFuelLevyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  fuelLevy?: Maybe<FuelLevy>;
  fuelLevyEdge?: Maybe<FuelLeviesEdge>;
  query?: Maybe<Query>;
};


export type CreateFuelLevyPayloadFuelLevyEdgeArgs = {
  orderBy?: InputMaybe<Array<FuelLeviesOrderBy>>;
};

export type CreateParkPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  parkPrice: ParkPriceInput;
};

export type CreateParkPricePayload = {
  __typename?: 'CreateParkPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  parkPrice?: Maybe<ParkPrice>;
  parkPriceEdge?: Maybe<ParkPricesEdge>;
  query?: Maybe<Query>;
  stateByStateId?: Maybe<State>;
  truckCompanyByCompanyId?: Maybe<TruckCompany>;
};


export type CreateParkPricePayloadParkPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<ParkPricesOrderBy>>;
};

export type CreatePortInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  port: PortInput;
};

export type CreatePortPayload = {
  __typename?: 'CreatePortPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  port?: Maybe<Port>;
  portEdge?: Maybe<PortsEdge>;
  query?: Maybe<Query>;
};


export type CreatePortPayloadPortEdgeArgs = {
  orderBy?: InputMaybe<Array<PortsOrderBy>>;
};

export type CreateRouteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  route: RouteInput;
};

export type CreateRoutePayload = {
  __typename?: 'CreateRoutePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  route?: Maybe<Route>;
  routeEdge?: Maybe<RoutesEdge>;
};


export type CreateRoutePayloadRouteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};

export type CreateRoutePortInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  routePort: RoutePortInput;
};

export type CreateRoutePortPayload = {
  __typename?: 'CreateRoutePortPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  portByPortId?: Maybe<Port>;
  query?: Maybe<Query>;
  routeByRouteId?: Maybe<Route>;
  routePort?: Maybe<RoutePort>;
  routePortEdge?: Maybe<RoutePortsEdge>;
};


export type CreateRoutePortPayloadRoutePortEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutePortsOrderBy>>;
};

export type CreateRouteVesselInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  routeVessel: RouteVesselInput;
};

export type CreateRouteVesselPayload = {
  __typename?: 'CreateRouteVesselPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  routeByRouteId?: Maybe<Route>;
  routeVessel?: Maybe<RouteVessel>;
  routeVesselEdge?: Maybe<RouteVesselsEdge>;
  vesselByVesselId?: Maybe<Vessel>;
};


export type CreateRouteVesselPayloadRouteVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<RouteVesselsOrderBy>>;
};

export type CreateShipCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shipCompany: ShipCompanyInput;
};

export type CreateShipCompanyPayload = {
  __typename?: 'CreateShipCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  shipCompany?: Maybe<ShipCompany>;
  shipCompanyEdge?: Maybe<ShipCompaniesEdge>;
};


export type CreateShipCompanyPayloadShipCompanyEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipCompaniesOrderBy>>;
};

export type CreateStateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  state: StateInput;
};

export type CreateStatePayload = {
  __typename?: 'CreateStatePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  query?: Maybe<Query>;
  state?: Maybe<State>;
  stateEdge?: Maybe<StatesEdge>;
};


export type CreateStatePayloadStateEdgeArgs = {
  orderBy?: InputMaybe<Array<StatesOrderBy>>;
};

export type CreateSuburbInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  suburb: SuburbInput;
};

export type CreateSuburbPayload = {
  __typename?: 'CreateSuburbPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  stateByStateCode?: Maybe<State>;
  suburb?: Maybe<Suburb>;
  suburbEdge?: Maybe<SuburbsEdge>;
};


export type CreateSuburbPayloadSuburbEdgeArgs = {
  orderBy?: InputMaybe<Array<SuburbsOrderBy>>;
};

export type CreateTollFeeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tollFee: TollFeeInput;
};

export type CreateTollFeePayload = {
  __typename?: 'CreateTollFeePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  stateByStateId?: Maybe<State>;
  tollFee?: Maybe<TollFee>;
  tollFeeEdge?: Maybe<TollFeesEdge>;
  truckCompanyByCompanyId?: Maybe<TruckCompany>;
};


export type CreateTollFeePayloadTollFeeEdgeArgs = {
  orderBy?: InputMaybe<Array<TollFeesOrderBy>>;
};

export type CreateTransportPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  transportPrice: TransportPriceInput;
};

export type CreateTransportPricePayload = {
  __typename?: 'CreateTransportPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  suburbBySuburbId?: Maybe<Suburb>;
  transportPrice?: Maybe<TransportPrice>;
  transportPriceEdge?: Maybe<TransportPricesEdge>;
  truckCompanyByTruckCompanyId?: Maybe<TruckCompany>;
};


export type CreateTransportPricePayloadTransportPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<TransportPricesOrderBy>>;
};

export type CreateTruckCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  truckCompany: TruckCompanyInput;
};

export type CreateTruckCompanyPayload = {
  __typename?: 'CreateTruckCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  truckCompany?: Maybe<TruckCompany>;
  truckCompanyEdge?: Maybe<TruckCompaniesEdge>;
};


export type CreateTruckCompanyPayloadTruckCompanyEdgeArgs = {
  orderBy?: InputMaybe<Array<TruckCompaniesOrderBy>>;
};

export type CreateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  user: UserInput;
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
  userEdge?: Maybe<UsersEdge>;
};


export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type CreateVesselInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vessel: VesselInput;
};

export type CreateVesselPayload = {
  __typename?: 'CreateVesselPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  shipCompanyByShipCompanyId?: Maybe<ShipCompany>;
  vessel?: Maybe<Vessel>;
  vesselEdge?: Maybe<VesselsEdge>;
};


export type CreateVesselPayloadVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

export type CreateWharfPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  wharfPrice: WharfPriceInput;
};

export type CreateWharfPricePayload = {
  __typename?: 'CreateWharfPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  stateByStateId?: Maybe<State>;
  truckCompanyByTruckCompanyId?: Maybe<TruckCompany>;
  wharfPrice?: Maybe<WharfPrice>;
  wharfPriceEdge?: Maybe<WharfPricesEdge>;
};


export type CreateWharfPricePayloadWharfPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<WharfPricesOrderBy>>;
};

export type DateFilter = {
  distinctFrom?: InputMaybe<Scalars['Date']['input']>;
  equalTo?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  notDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  notEqualTo?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

export enum DateType {
  Eta = 'ETA',
  Etd = 'ETD'
}

export type DateTypeFilter = {
  distinctFrom?: InputMaybe<DateType>;
  equalTo?: InputMaybe<DateType>;
  greaterThan?: InputMaybe<DateType>;
  greaterThanOrEqualTo?: InputMaybe<DateType>;
  in?: InputMaybe<Array<DateType>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<DateType>;
  lessThanOrEqualTo?: InputMaybe<DateType>;
  notDistinctFrom?: InputMaybe<DateType>;
  notEqualTo?: InputMaybe<DateType>;
  notIn?: InputMaybe<Array<DateType>>;
};

export type DatetimeFilter = {
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export type DeleteAddressByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

export type DeleteAddressInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteAddressPayload = {
  __typename?: 'DeleteAddressPayload';
  address?: Maybe<Address>;
  addressEdge?: Maybe<AddressesEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  deletedAddressId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
};


export type DeleteAddressPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};

export type DeleteAgentByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteAgentByNameInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DeleteAgentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteAgentPayload = {
  __typename?: 'DeleteAgentPayload';
  agent?: Maybe<Agent>;
  agentEdge?: Maybe<AgentsEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  deletedAgentId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
};


export type DeleteAgentPayloadAgentEdgeArgs = {
  orderBy?: InputMaybe<Array<AgentsOrderBy>>;
};

export type DeleteBookingByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteBookingInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteBookingPayload = {
  __typename?: 'DeleteBookingPayload';
  agentByAgentId?: Maybe<Agent>;
  booking?: Maybe<Booking>;
  bookingEdge?: Maybe<BookingsEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBookingId?: Maybe<Scalars['ID']['output']>;
  portByDischargePort?: Maybe<Port>;
  portByPod?: Maybe<Port>;
  portByPol?: Maybe<Port>;
  query?: Maybe<Query>;
  routeByRouteId?: Maybe<Route>;
  routeVesselByRouteVesselId?: Maybe<RouteVessel>;
};


export type DeleteBookingPayloadBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};

export type DeleteBookingPriceByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteBookingPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteBookingPricePayload = {
  __typename?: 'DeleteBookingPricePayload';
  bookingByBookingId?: Maybe<Booking>;
  bookingPrice?: Maybe<BookingPrice>;
  bookingPriceEdge?: Maybe<BookingPricesEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBookingPriceId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
};


export type DeleteBookingPricePayloadBookingPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<BookingPricesOrderBy>>;
};

export type DeleteCountryByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteCountryByIsoCode2Input = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isoCode2: Scalars['String']['input'];
};

export type DeleteCountryByIsoCode3Input = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isoCode3: Scalars['String']['input'];
};

export type DeleteCountryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteCountryPayload = {
  __typename?: 'DeleteCountryPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryEdge?: Maybe<CountriesEdge>;
  deletedCountryId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
};


export type DeleteCountryPayloadCountryEdgeArgs = {
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};

export type DeleteFuelLevyByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

export type DeleteFuelLevyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteFuelLevyPayload = {
  __typename?: 'DeleteFuelLevyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFuelLevyId?: Maybe<Scalars['ID']['output']>;
  fuelLevy?: Maybe<FuelLevy>;
  fuelLevyEdge?: Maybe<FuelLeviesEdge>;
  query?: Maybe<Query>;
};


export type DeleteFuelLevyPayloadFuelLevyEdgeArgs = {
  orderBy?: InputMaybe<Array<FuelLeviesOrderBy>>;
};

export type DeleteParkPriceByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteParkPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteParkPricePayload = {
  __typename?: 'DeleteParkPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedParkPriceId?: Maybe<Scalars['ID']['output']>;
  parkPrice?: Maybe<ParkPrice>;
  parkPriceEdge?: Maybe<ParkPricesEdge>;
  query?: Maybe<Query>;
  stateByStateId?: Maybe<State>;
  truckCompanyByCompanyId?: Maybe<TruckCompany>;
};


export type DeleteParkPricePayloadParkPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<ParkPricesOrderBy>>;
};

export type DeletePortByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeletePortByNameInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DeletePortInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeletePortPayload = {
  __typename?: 'DeletePortPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  deletedPortId?: Maybe<Scalars['ID']['output']>;
  port?: Maybe<Port>;
  portEdge?: Maybe<PortsEdge>;
  query?: Maybe<Query>;
};


export type DeletePortPayloadPortEdgeArgs = {
  orderBy?: InputMaybe<Array<PortsOrderBy>>;
};

export type DeleteRouteByCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
};

export type DeleteRouteByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteRouteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteRoutePayload = {
  __typename?: 'DeleteRoutePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRouteId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  route?: Maybe<Route>;
  routeEdge?: Maybe<RoutesEdge>;
};


export type DeleteRoutePayloadRouteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};

export type DeleteRoutePortByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteRoutePortInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteRoutePortPayload = {
  __typename?: 'DeleteRoutePortPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRoutePortId?: Maybe<Scalars['ID']['output']>;
  portByPortId?: Maybe<Port>;
  query?: Maybe<Query>;
  routeByRouteId?: Maybe<Route>;
  routePort?: Maybe<RoutePort>;
  routePortEdge?: Maybe<RoutePortsEdge>;
};


export type DeleteRoutePortPayloadRoutePortEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutePortsOrderBy>>;
};

export type DeleteRouteVesselByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteRouteVesselInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteRouteVesselPayload = {
  __typename?: 'DeleteRouteVesselPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRouteVesselId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  routeByRouteId?: Maybe<Route>;
  routeVessel?: Maybe<RouteVessel>;
  routeVesselEdge?: Maybe<RouteVesselsEdge>;
  vesselByVesselId?: Maybe<Vessel>;
};


export type DeleteRouteVesselPayloadRouteVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<RouteVesselsOrderBy>>;
};

export type DeleteShipCompanyByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteShipCompanyByNameInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DeleteShipCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteShipCompanyPayload = {
  __typename?: 'DeleteShipCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedShipCompanyId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  shipCompany?: Maybe<ShipCompany>;
  shipCompanyEdge?: Maybe<ShipCompaniesEdge>;
};


export type DeleteShipCompanyPayloadShipCompanyEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipCompaniesOrderBy>>;
};

export type DeleteStateByCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
};

export type DeleteStateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteStatePayload = {
  __typename?: 'DeleteStatePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  deletedStateId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  state?: Maybe<State>;
  stateEdge?: Maybe<StatesEdge>;
};


export type DeleteStatePayloadStateEdgeArgs = {
  orderBy?: InputMaybe<Array<StatesOrderBy>>;
};

export type DeleteSuburbByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

export type DeleteSuburbByNameAndStateCodeAndPostcodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
};

export type DeleteSuburbInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteSuburbPayload = {
  __typename?: 'DeleteSuburbPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSuburbId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  stateByStateCode?: Maybe<State>;
  suburb?: Maybe<Suburb>;
  suburbEdge?: Maybe<SuburbsEdge>;
};


export type DeleteSuburbPayloadSuburbEdgeArgs = {
  orderBy?: InputMaybe<Array<SuburbsOrderBy>>;
};

export type DeleteTollFeeByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

export type DeleteTollFeeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteTollFeePayload = {
  __typename?: 'DeleteTollFeePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTollFeeId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  stateByStateId?: Maybe<State>;
  tollFee?: Maybe<TollFee>;
  tollFeeEdge?: Maybe<TollFeesEdge>;
  truckCompanyByCompanyId?: Maybe<TruckCompany>;
};


export type DeleteTollFeePayloadTollFeeEdgeArgs = {
  orderBy?: InputMaybe<Array<TollFeesOrderBy>>;
};

export type DeleteTransportPriceByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteTransportPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteTransportPricePayload = {
  __typename?: 'DeleteTransportPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTransportPriceId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  suburbBySuburbId?: Maybe<Suburb>;
  transportPrice?: Maybe<TransportPrice>;
  transportPriceEdge?: Maybe<TransportPricesEdge>;
  truckCompanyByTruckCompanyId?: Maybe<TruckCompany>;
};


export type DeleteTransportPricePayloadTransportPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<TransportPricesOrderBy>>;
};

export type DeleteTruckCompanyByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

export type DeleteTruckCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteTruckCompanyPayload = {
  __typename?: 'DeleteTruckCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTruckCompanyId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  truckCompany?: Maybe<TruckCompany>;
  truckCompanyEdge?: Maybe<TruckCompaniesEdge>;
};


export type DeleteTruckCompanyPayloadTruckCompanyEdgeArgs = {
  orderBy?: InputMaybe<Array<TruckCompaniesOrderBy>>;
};

export type DeleteUserByAuth0IdInput = {
  auth0Id: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteUserByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
  userEdge?: Maybe<UsersEdge>;
};


export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type DeleteVesselByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteVesselInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteVesselPayload = {
  __typename?: 'DeleteVesselPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  shipCompanyByShipCompanyId?: Maybe<ShipCompany>;
  vessel?: Maybe<Vessel>;
  vesselEdge?: Maybe<VesselsEdge>;
};


export type DeleteVesselPayloadVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

export type DeleteWharfPriceByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type DeleteWharfPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type DeleteWharfPricePayload = {
  __typename?: 'DeleteWharfPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWharfPriceId?: Maybe<Scalars['ID']['output']>;
  query?: Maybe<Query>;
  stateByStateId?: Maybe<State>;
  truckCompanyByTruckCompanyId?: Maybe<TruckCompany>;
  wharfPrice?: Maybe<WharfPrice>;
  wharfPriceEdge?: Maybe<WharfPricesEdge>;
};


export type DeleteWharfPricePayloadWharfPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<WharfPricesOrderBy>>;
};

export enum Dow {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export type DowFilter = {
  distinctFrom?: InputMaybe<Dow>;
  equalTo?: InputMaybe<Dow>;
  greaterThan?: InputMaybe<Dow>;
  greaterThanOrEqualTo?: InputMaybe<Dow>;
  in?: InputMaybe<Array<Dow>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Dow>;
  lessThanOrEqualTo?: InputMaybe<Dow>;
  notDistinctFrom?: InputMaybe<Dow>;
  notEqualTo?: InputMaybe<Dow>;
  notIn?: InputMaybe<Array<Dow>>;
};

export type FUpdateRoutePortsInput = {
  _ports?: InputMaybe<Scalars['JSON']['input']>;
  _routeId?: InputMaybe<Scalars['Int']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type FUpdateRoutePortsPayload = {
  __typename?: 'FUpdateRoutePortsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
};

export type FUpdateTierPricesInput = {
  _bookingId?: InputMaybe<Scalars['Int']['input']>;
  _prices?: InputMaybe<Scalars['JSON']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type FUpdateTierPricesPayload = {
  __typename?: 'FUpdateTierPricesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
};

export type FuelLeviesConnection = {
  __typename?: 'FuelLeviesConnection';
  edges: Array<FuelLeviesEdge>;
  nodes: Array<Maybe<FuelLevy>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FuelLeviesEdge = {
  __typename?: 'FuelLeviesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<FuelLevy>;
};

export enum FuelLeviesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LevyAsc = 'LEVY_ASC',
  LevyDesc = 'LEVY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TruckCompanyIdAsc = 'TRUCK_COMPANY_ID_ASC',
  TruckCompanyIdDesc = 'TRUCK_COMPANY_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValidFromAsc = 'VALID_FROM_ASC',
  ValidFromDesc = 'VALID_FROM_DESC',
  ValidToAsc = 'VALID_TO_ASC',
  ValidToDesc = 'VALID_TO_DESC'
}

export type FuelLevy = Node & {
  __typename?: 'FuelLevy';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['BigInt']['output'];
  levy?: Maybe<Scalars['BigFloat']['output']>;
  nodeId: Scalars['ID']['output'];
  truckCompanyId: Scalars['BigInt']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  validFrom?: Maybe<Scalars['Datetime']['output']>;
  validTo?: Maybe<Scalars['Datetime']['output']>;
};

export type FuelLevyCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  levy?: InputMaybe<Scalars['BigFloat']['input']>;
  truckCompanyId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type FuelLevyFilter = {
  and?: InputMaybe<Array<FuelLevyFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<BigIntFilter>;
  levy?: InputMaybe<BigFloatFilter>;
  not?: InputMaybe<FuelLevyFilter>;
  or?: InputMaybe<Array<FuelLevyFilter>>;
  truckCompanyId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  validFrom?: InputMaybe<DatetimeFilter>;
  validTo?: InputMaybe<DatetimeFilter>;
};

export type FuelLevyInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  levy?: InputMaybe<Scalars['BigFloat']['input']>;
  truckCompanyId: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type FuelLevyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  levy?: InputMaybe<Scalars['BigFloat']['input']>;
  truckCompanyId?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type IntFilter = {
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonFilter = {
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  containsKey?: InputMaybe<Scalars['String']['input']>;
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAddress?: Maybe<CreateAddressPayload>;
  createAgent?: Maybe<CreateAgentPayload>;
  createBooking?: Maybe<CreateBookingPayload>;
  createBookingPrice?: Maybe<CreateBookingPricePayload>;
  createCountry?: Maybe<CreateCountryPayload>;
  createFuelLevy?: Maybe<CreateFuelLevyPayload>;
  createParkPrice?: Maybe<CreateParkPricePayload>;
  createPort?: Maybe<CreatePortPayload>;
  createRoute?: Maybe<CreateRoutePayload>;
  createRoutePort?: Maybe<CreateRoutePortPayload>;
  createRouteVessel?: Maybe<CreateRouteVesselPayload>;
  createShipCompany?: Maybe<CreateShipCompanyPayload>;
  createState?: Maybe<CreateStatePayload>;
  createSuburb?: Maybe<CreateSuburbPayload>;
  createTollFee?: Maybe<CreateTollFeePayload>;
  createTransportPrice?: Maybe<CreateTransportPricePayload>;
  createTruckCompany?: Maybe<CreateTruckCompanyPayload>;
  createUser?: Maybe<CreateUserPayload>;
  createVessel?: Maybe<CreateVesselPayload>;
  createWharfPrice?: Maybe<CreateWharfPricePayload>;
  deleteAddress?: Maybe<DeleteAddressPayload>;
  deleteAddressById?: Maybe<DeleteAddressPayload>;
  deleteAgent?: Maybe<DeleteAgentPayload>;
  deleteAgentById?: Maybe<DeleteAgentPayload>;
  deleteAgentByName?: Maybe<DeleteAgentPayload>;
  deleteBooking?: Maybe<DeleteBookingPayload>;
  deleteBookingById?: Maybe<DeleteBookingPayload>;
  deleteBookingPrice?: Maybe<DeleteBookingPricePayload>;
  deleteBookingPriceById?: Maybe<DeleteBookingPricePayload>;
  deleteCountry?: Maybe<DeleteCountryPayload>;
  deleteCountryById?: Maybe<DeleteCountryPayload>;
  deleteCountryByIsoCode2?: Maybe<DeleteCountryPayload>;
  deleteCountryByIsoCode3?: Maybe<DeleteCountryPayload>;
  deleteFuelLevy?: Maybe<DeleteFuelLevyPayload>;
  deleteFuelLevyById?: Maybe<DeleteFuelLevyPayload>;
  deleteParkPrice?: Maybe<DeleteParkPricePayload>;
  deleteParkPriceById?: Maybe<DeleteParkPricePayload>;
  deletePort?: Maybe<DeletePortPayload>;
  deletePortById?: Maybe<DeletePortPayload>;
  deletePortByName?: Maybe<DeletePortPayload>;
  deleteRoute?: Maybe<DeleteRoutePayload>;
  deleteRouteByCode?: Maybe<DeleteRoutePayload>;
  deleteRouteById?: Maybe<DeleteRoutePayload>;
  deleteRoutePort?: Maybe<DeleteRoutePortPayload>;
  deleteRoutePortById?: Maybe<DeleteRoutePortPayload>;
  deleteRouteVessel?: Maybe<DeleteRouteVesselPayload>;
  deleteRouteVesselById?: Maybe<DeleteRouteVesselPayload>;
  deleteShipCompany?: Maybe<DeleteShipCompanyPayload>;
  deleteShipCompanyById?: Maybe<DeleteShipCompanyPayload>;
  deleteShipCompanyByName?: Maybe<DeleteShipCompanyPayload>;
  deleteState?: Maybe<DeleteStatePayload>;
  deleteStateByCode?: Maybe<DeleteStatePayload>;
  deleteSuburb?: Maybe<DeleteSuburbPayload>;
  deleteSuburbById?: Maybe<DeleteSuburbPayload>;
  deleteSuburbByNameAndStateCodeAndPostcode?: Maybe<DeleteSuburbPayload>;
  deleteTollFee?: Maybe<DeleteTollFeePayload>;
  deleteTollFeeById?: Maybe<DeleteTollFeePayload>;
  deleteTransportPrice?: Maybe<DeleteTransportPricePayload>;
  deleteTransportPriceById?: Maybe<DeleteTransportPricePayload>;
  deleteTruckCompany?: Maybe<DeleteTruckCompanyPayload>;
  deleteTruckCompanyById?: Maybe<DeleteTruckCompanyPayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteUserByAuth0Id?: Maybe<DeleteUserPayload>;
  deleteUserById?: Maybe<DeleteUserPayload>;
  deleteVessel?: Maybe<DeleteVesselPayload>;
  deleteVesselById?: Maybe<DeleteVesselPayload>;
  deleteWharfPrice?: Maybe<DeleteWharfPricePayload>;
  deleteWharfPriceById?: Maybe<DeleteWharfPricePayload>;
  fUpdateRoutePorts?: Maybe<FUpdateRoutePortsPayload>;
  fUpdateTierPrices?: Maybe<FUpdateTierPricesPayload>;
  updateAddress?: Maybe<UpdateAddressPayload>;
  updateAddressById?: Maybe<UpdateAddressPayload>;
  updateAgent?: Maybe<UpdateAgentPayload>;
  updateAgentById?: Maybe<UpdateAgentPayload>;
  updateAgentByName?: Maybe<UpdateAgentPayload>;
  updateBooking?: Maybe<UpdateBookingPayload>;
  updateBookingById?: Maybe<UpdateBookingPayload>;
  updateBookingPrice?: Maybe<UpdateBookingPricePayload>;
  updateBookingPriceById?: Maybe<UpdateBookingPricePayload>;
  updateCountry?: Maybe<UpdateCountryPayload>;
  updateCountryById?: Maybe<UpdateCountryPayload>;
  updateCountryByIsoCode2?: Maybe<UpdateCountryPayload>;
  updateCountryByIsoCode3?: Maybe<UpdateCountryPayload>;
  updateFuelLevy?: Maybe<UpdateFuelLevyPayload>;
  updateFuelLevyById?: Maybe<UpdateFuelLevyPayload>;
  updateParkPrice?: Maybe<UpdateParkPricePayload>;
  updateParkPriceById?: Maybe<UpdateParkPricePayload>;
  updatePort?: Maybe<UpdatePortPayload>;
  updatePortById?: Maybe<UpdatePortPayload>;
  updatePortByName?: Maybe<UpdatePortPayload>;
  updateRoute?: Maybe<UpdateRoutePayload>;
  updateRouteByCode?: Maybe<UpdateRoutePayload>;
  updateRouteById?: Maybe<UpdateRoutePayload>;
  updateRoutePort?: Maybe<UpdateRoutePortPayload>;
  updateRoutePortById?: Maybe<UpdateRoutePortPayload>;
  updateRouteVessel?: Maybe<UpdateRouteVesselPayload>;
  updateRouteVesselById?: Maybe<UpdateRouteVesselPayload>;
  updateShipCompany?: Maybe<UpdateShipCompanyPayload>;
  updateShipCompanyById?: Maybe<UpdateShipCompanyPayload>;
  updateShipCompanyByName?: Maybe<UpdateShipCompanyPayload>;
  updateState?: Maybe<UpdateStatePayload>;
  updateStateByCode?: Maybe<UpdateStatePayload>;
  updateSuburb?: Maybe<UpdateSuburbPayload>;
  updateSuburbById?: Maybe<UpdateSuburbPayload>;
  updateSuburbByNameAndStateCodeAndPostcode?: Maybe<UpdateSuburbPayload>;
  updateTollFee?: Maybe<UpdateTollFeePayload>;
  updateTollFeeById?: Maybe<UpdateTollFeePayload>;
  updateTransportPrice?: Maybe<UpdateTransportPricePayload>;
  updateTransportPriceById?: Maybe<UpdateTransportPricePayload>;
  updateTruckCompany?: Maybe<UpdateTruckCompanyPayload>;
  updateTruckCompanyById?: Maybe<UpdateTruckCompanyPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserByAuth0Id?: Maybe<UpdateUserPayload>;
  updateUserById?: Maybe<UpdateUserPayload>;
  updateVessel?: Maybe<UpdateVesselPayload>;
  updateVesselById?: Maybe<UpdateVesselPayload>;
  updateWharfPrice?: Maybe<UpdateWharfPricePayload>;
  updateWharfPriceById?: Maybe<UpdateWharfPricePayload>;
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateAgentArgs = {
  input: CreateAgentInput;
};


export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


export type MutationCreateBookingPriceArgs = {
  input: CreateBookingPriceInput;
};


export type MutationCreateCountryArgs = {
  input: CreateCountryInput;
};


export type MutationCreateFuelLevyArgs = {
  input: CreateFuelLevyInput;
};


export type MutationCreateParkPriceArgs = {
  input: CreateParkPriceInput;
};


export type MutationCreatePortArgs = {
  input: CreatePortInput;
};


export type MutationCreateRouteArgs = {
  input: CreateRouteInput;
};


export type MutationCreateRoutePortArgs = {
  input: CreateRoutePortInput;
};


export type MutationCreateRouteVesselArgs = {
  input: CreateRouteVesselInput;
};


export type MutationCreateShipCompanyArgs = {
  input: CreateShipCompanyInput;
};


export type MutationCreateStateArgs = {
  input: CreateStateInput;
};


export type MutationCreateSuburbArgs = {
  input: CreateSuburbInput;
};


export type MutationCreateTollFeeArgs = {
  input: CreateTollFeeInput;
};


export type MutationCreateTransportPriceArgs = {
  input: CreateTransportPriceInput;
};


export type MutationCreateTruckCompanyArgs = {
  input: CreateTruckCompanyInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVesselArgs = {
  input: CreateVesselInput;
};


export type MutationCreateWharfPriceArgs = {
  input: CreateWharfPriceInput;
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput;
};


export type MutationDeleteAddressByIdArgs = {
  input: DeleteAddressByIdInput;
};


export type MutationDeleteAgentArgs = {
  input: DeleteAgentInput;
};


export type MutationDeleteAgentByIdArgs = {
  input: DeleteAgentByIdInput;
};


export type MutationDeleteAgentByNameArgs = {
  input: DeleteAgentByNameInput;
};


export type MutationDeleteBookingArgs = {
  input: DeleteBookingInput;
};


export type MutationDeleteBookingByIdArgs = {
  input: DeleteBookingByIdInput;
};


export type MutationDeleteBookingPriceArgs = {
  input: DeleteBookingPriceInput;
};


export type MutationDeleteBookingPriceByIdArgs = {
  input: DeleteBookingPriceByIdInput;
};


export type MutationDeleteCountryArgs = {
  input: DeleteCountryInput;
};


export type MutationDeleteCountryByIdArgs = {
  input: DeleteCountryByIdInput;
};


export type MutationDeleteCountryByIsoCode2Args = {
  input: DeleteCountryByIsoCode2Input;
};


export type MutationDeleteCountryByIsoCode3Args = {
  input: DeleteCountryByIsoCode3Input;
};


export type MutationDeleteFuelLevyArgs = {
  input: DeleteFuelLevyInput;
};


export type MutationDeleteFuelLevyByIdArgs = {
  input: DeleteFuelLevyByIdInput;
};


export type MutationDeleteParkPriceArgs = {
  input: DeleteParkPriceInput;
};


export type MutationDeleteParkPriceByIdArgs = {
  input: DeleteParkPriceByIdInput;
};


export type MutationDeletePortArgs = {
  input: DeletePortInput;
};


export type MutationDeletePortByIdArgs = {
  input: DeletePortByIdInput;
};


export type MutationDeletePortByNameArgs = {
  input: DeletePortByNameInput;
};


export type MutationDeleteRouteArgs = {
  input: DeleteRouteInput;
};


export type MutationDeleteRouteByCodeArgs = {
  input: DeleteRouteByCodeInput;
};


export type MutationDeleteRouteByIdArgs = {
  input: DeleteRouteByIdInput;
};


export type MutationDeleteRoutePortArgs = {
  input: DeleteRoutePortInput;
};


export type MutationDeleteRoutePortByIdArgs = {
  input: DeleteRoutePortByIdInput;
};


export type MutationDeleteRouteVesselArgs = {
  input: DeleteRouteVesselInput;
};


export type MutationDeleteRouteVesselByIdArgs = {
  input: DeleteRouteVesselByIdInput;
};


export type MutationDeleteShipCompanyArgs = {
  input: DeleteShipCompanyInput;
};


export type MutationDeleteShipCompanyByIdArgs = {
  input: DeleteShipCompanyByIdInput;
};


export type MutationDeleteShipCompanyByNameArgs = {
  input: DeleteShipCompanyByNameInput;
};


export type MutationDeleteStateArgs = {
  input: DeleteStateInput;
};


export type MutationDeleteStateByCodeArgs = {
  input: DeleteStateByCodeInput;
};


export type MutationDeleteSuburbArgs = {
  input: DeleteSuburbInput;
};


export type MutationDeleteSuburbByIdArgs = {
  input: DeleteSuburbByIdInput;
};


export type MutationDeleteSuburbByNameAndStateCodeAndPostcodeArgs = {
  input: DeleteSuburbByNameAndStateCodeAndPostcodeInput;
};


export type MutationDeleteTollFeeArgs = {
  input: DeleteTollFeeInput;
};


export type MutationDeleteTollFeeByIdArgs = {
  input: DeleteTollFeeByIdInput;
};


export type MutationDeleteTransportPriceArgs = {
  input: DeleteTransportPriceInput;
};


export type MutationDeleteTransportPriceByIdArgs = {
  input: DeleteTransportPriceByIdInput;
};


export type MutationDeleteTruckCompanyArgs = {
  input: DeleteTruckCompanyInput;
};


export type MutationDeleteTruckCompanyByIdArgs = {
  input: DeleteTruckCompanyByIdInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteUserByAuth0IdArgs = {
  input: DeleteUserByAuth0IdInput;
};


export type MutationDeleteUserByIdArgs = {
  input: DeleteUserByIdInput;
};


export type MutationDeleteVesselArgs = {
  input: DeleteVesselInput;
};


export type MutationDeleteVesselByIdArgs = {
  input: DeleteVesselByIdInput;
};


export type MutationDeleteWharfPriceArgs = {
  input: DeleteWharfPriceInput;
};


export type MutationDeleteWharfPriceByIdArgs = {
  input: DeleteWharfPriceByIdInput;
};


export type MutationFUpdateRoutePortsArgs = {
  input: FUpdateRoutePortsInput;
};


export type MutationFUpdateTierPricesArgs = {
  input: FUpdateTierPricesInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAddressByIdArgs = {
  input: UpdateAddressByIdInput;
};


export type MutationUpdateAgentArgs = {
  input: UpdateAgentInput;
};


export type MutationUpdateAgentByIdArgs = {
  input: UpdateAgentByIdInput;
};


export type MutationUpdateAgentByNameArgs = {
  input: UpdateAgentByNameInput;
};


export type MutationUpdateBookingArgs = {
  input: UpdateBookingInput;
};


export type MutationUpdateBookingByIdArgs = {
  input: UpdateBookingByIdInput;
};


export type MutationUpdateBookingPriceArgs = {
  input: UpdateBookingPriceInput;
};


export type MutationUpdateBookingPriceByIdArgs = {
  input: UpdateBookingPriceByIdInput;
};


export type MutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


export type MutationUpdateCountryByIdArgs = {
  input: UpdateCountryByIdInput;
};


export type MutationUpdateCountryByIsoCode2Args = {
  input: UpdateCountryByIsoCode2Input;
};


export type MutationUpdateCountryByIsoCode3Args = {
  input: UpdateCountryByIsoCode3Input;
};


export type MutationUpdateFuelLevyArgs = {
  input: UpdateFuelLevyInput;
};


export type MutationUpdateFuelLevyByIdArgs = {
  input: UpdateFuelLevyByIdInput;
};


export type MutationUpdateParkPriceArgs = {
  input: UpdateParkPriceInput;
};


export type MutationUpdateParkPriceByIdArgs = {
  input: UpdateParkPriceByIdInput;
};


export type MutationUpdatePortArgs = {
  input: UpdatePortInput;
};


export type MutationUpdatePortByIdArgs = {
  input: UpdatePortByIdInput;
};


export type MutationUpdatePortByNameArgs = {
  input: UpdatePortByNameInput;
};


export type MutationUpdateRouteArgs = {
  input: UpdateRouteInput;
};


export type MutationUpdateRouteByCodeArgs = {
  input: UpdateRouteByCodeInput;
};


export type MutationUpdateRouteByIdArgs = {
  input: UpdateRouteByIdInput;
};


export type MutationUpdateRoutePortArgs = {
  input: UpdateRoutePortInput;
};


export type MutationUpdateRoutePortByIdArgs = {
  input: UpdateRoutePortByIdInput;
};


export type MutationUpdateRouteVesselArgs = {
  input: UpdateRouteVesselInput;
};


export type MutationUpdateRouteVesselByIdArgs = {
  input: UpdateRouteVesselByIdInput;
};


export type MutationUpdateShipCompanyArgs = {
  input: UpdateShipCompanyInput;
};


export type MutationUpdateShipCompanyByIdArgs = {
  input: UpdateShipCompanyByIdInput;
};


export type MutationUpdateShipCompanyByNameArgs = {
  input: UpdateShipCompanyByNameInput;
};


export type MutationUpdateStateArgs = {
  input: UpdateStateInput;
};


export type MutationUpdateStateByCodeArgs = {
  input: UpdateStateByCodeInput;
};


export type MutationUpdateSuburbArgs = {
  input: UpdateSuburbInput;
};


export type MutationUpdateSuburbByIdArgs = {
  input: UpdateSuburbByIdInput;
};


export type MutationUpdateSuburbByNameAndStateCodeAndPostcodeArgs = {
  input: UpdateSuburbByNameAndStateCodeAndPostcodeInput;
};


export type MutationUpdateTollFeeArgs = {
  input: UpdateTollFeeInput;
};


export type MutationUpdateTollFeeByIdArgs = {
  input: UpdateTollFeeByIdInput;
};


export type MutationUpdateTransportPriceArgs = {
  input: UpdateTransportPriceInput;
};


export type MutationUpdateTransportPriceByIdArgs = {
  input: UpdateTransportPriceByIdInput;
};


export type MutationUpdateTruckCompanyArgs = {
  input: UpdateTruckCompanyInput;
};


export type MutationUpdateTruckCompanyByIdArgs = {
  input: UpdateTruckCompanyByIdInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserByAuth0IdArgs = {
  input: UpdateUserByAuth0IdInput;
};


export type MutationUpdateUserByIdArgs = {
  input: UpdateUserByIdInput;
};


export type MutationUpdateVesselArgs = {
  input: UpdateVesselInput;
};


export type MutationUpdateVesselByIdArgs = {
  input: UpdateVesselByIdInput;
};


export type MutationUpdateWharfPriceArgs = {
  input: UpdateWharfPriceInput;
};


export type MutationUpdateWharfPriceByIdArgs = {
  input: UpdateWharfPriceByIdInput;
};

export type Node = {
  nodeId: Scalars['ID']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type ParkPrice = Node & {
  __typename?: 'ParkPrice';
  companyId?: Maybe<Scalars['BigInt']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  nodeId: Scalars['ID']['output'];
  parkName?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['BigFloat']['output']>;
  stateByStateId?: Maybe<State>;
  stateId?: Maybe<Scalars['String']['output']>;
  truckCompanyByCompanyId?: Maybe<TruckCompany>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type ParkPriceCondition = {
  companyId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parkName?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type ParkPriceFilter = {
  and?: InputMaybe<Array<ParkPriceFilter>>;
  companyId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  not?: InputMaybe<ParkPriceFilter>;
  or?: InputMaybe<Array<ParkPriceFilter>>;
  parkName?: InputMaybe<StringFilter>;
  price?: InputMaybe<BigFloatFilter>;
  stateByStateId?: InputMaybe<StateFilter>;
  stateByStateIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  stateId?: InputMaybe<StringFilter>;
  truckCompanyByCompanyId?: InputMaybe<TruckCompanyFilter>;
  truckCompanyByCompanyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  validTo?: InputMaybe<DateFilter>;
};

export type ParkPriceInput = {
  companyId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parkName?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type ParkPricePatch = {
  companyId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parkName?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type ParkPricesConnection = {
  __typename?: 'ParkPricesConnection';
  edges: Array<ParkPricesEdge>;
  nodes: Array<Maybe<ParkPrice>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ParkPricesEdge = {
  __typename?: 'ParkPricesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<ParkPrice>;
};

export enum ParkPricesOrderBy {
  CompanyIdAsc = 'COMPANY_ID_ASC',
  CompanyIdDesc = 'COMPANY_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  ParkNameAsc = 'PARK_NAME_ASC',
  ParkNameDesc = 'PARK_NAME_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateIdAsc = 'STATE_ID_ASC',
  StateIdDesc = 'STATE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValidToAsc = 'VALID_TO_ASC',
  ValidToDesc = 'VALID_TO_DESC'
}

export type Port = Node & {
  __typename?: 'Port';
  bookingsByDischargePort: BookingsConnection;
  bookingsByPod: BookingsConnection;
  bookingsByPol: BookingsConnection;
  countryByCountryId?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  routePortsByPortId: RoutePortsConnection;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};


export type PortBookingsByDischargePortArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BookingCondition>;
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};


export type PortBookingsByPodArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BookingCondition>;
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};


export type PortBookingsByPolArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BookingCondition>;
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};


export type PortRoutePortsByPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoutePortCondition>;
  filter?: InputMaybe<RoutePortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutePortsOrderBy>>;
};

export type PortCondition = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PortFilter = {
  and?: InputMaybe<Array<PortFilter>>;
  bookingsByDischargePort?: InputMaybe<PortToManyBookingFilter>;
  bookingsByDischargePortExist?: InputMaybe<Scalars['Boolean']['input']>;
  bookingsByPod?: InputMaybe<PortToManyBookingFilter>;
  bookingsByPodExist?: InputMaybe<Scalars['Boolean']['input']>;
  bookingsByPol?: InputMaybe<PortToManyBookingFilter>;
  bookingsByPolExist?: InputMaybe<Scalars['Boolean']['input']>;
  countryByCountryId?: InputMaybe<CountryFilter>;
  countryByCountryIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<PortFilter>;
  or?: InputMaybe<Array<PortFilter>>;
  routePortsByPortId?: InputMaybe<PortToManyRoutePortFilter>;
  routePortsByPortIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type PortInput = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PortPatch = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PortToManyBookingFilter = {
  every?: InputMaybe<BookingFilter>;
  none?: InputMaybe<BookingFilter>;
  some?: InputMaybe<BookingFilter>;
};

export type PortToManyRoutePortFilter = {
  every?: InputMaybe<RoutePortFilter>;
  none?: InputMaybe<RoutePortFilter>;
  some?: InputMaybe<RoutePortFilter>;
};

export type PortsConnection = {
  __typename?: 'PortsConnection';
  edges: Array<PortsEdge>;
  nodes: Array<Maybe<Port>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PortsEdge = {
  __typename?: 'PortsEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<Port>;
};

export enum PortsOrderBy {
  CountryIdAsc = 'COUNTRY_ID_ASC',
  CountryIdDesc = 'COUNTRY_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Query = Node & {
  __typename?: 'Query';
  address?: Maybe<Address>;
  addressById?: Maybe<Address>;
  agent?: Maybe<Agent>;
  agentById?: Maybe<Agent>;
  agentByName?: Maybe<Agent>;
  allAddresses?: Maybe<AddressesConnection>;
  allAgents?: Maybe<AgentsConnection>;
  allBookingPrices?: Maybe<BookingPricesConnection>;
  allBookings?: Maybe<BookingsConnection>;
  allCountries?: Maybe<CountriesConnection>;
  allFuelLevies?: Maybe<FuelLeviesConnection>;
  allParkPrices?: Maybe<ParkPricesConnection>;
  allPorts?: Maybe<PortsConnection>;
  allRoutePorts?: Maybe<RoutePortsConnection>;
  allRouteVessels?: Maybe<RouteVesselsConnection>;
  allRoutes?: Maybe<RoutesConnection>;
  allShipCompanies?: Maybe<ShipCompaniesConnection>;
  allStates?: Maybe<StatesConnection>;
  allSuburbs?: Maybe<SuburbsConnection>;
  allTollFees?: Maybe<TollFeesConnection>;
  allTransportPrices?: Maybe<TransportPricesConnection>;
  allTruckCompanies?: Maybe<TruckCompaniesConnection>;
  allUsers?: Maybe<UsersConnection>;
  allVRouteEndpoints?: Maybe<VRouteEndpointsConnection>;
  allVessels?: Maybe<VesselsConnection>;
  allWharfPrices?: Maybe<WharfPricesConnection>;
  booking?: Maybe<Booking>;
  bookingById?: Maybe<Booking>;
  bookingPrice?: Maybe<BookingPrice>;
  bookingPriceById?: Maybe<BookingPrice>;
  country?: Maybe<Country>;
  countryById?: Maybe<Country>;
  countryByIsoCode2?: Maybe<Country>;
  countryByIsoCode3?: Maybe<Country>;
  currentUserAuth0Id?: Maybe<Scalars['String']['output']>;
  currentUserDatabaseId?: Maybe<Scalars['Int']['output']>;
  currentUserHasRole?: Maybe<Scalars['Boolean']['output']>;
  currentUserId?: Maybe<Scalars['Int']['output']>;
  currentUserIsAdmin?: Maybe<Scalars['Boolean']['output']>;
  currentUserIsAgentOrAbove?: Maybe<Scalars['Boolean']['output']>;
  currentUserIsAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  currentUserIsManagerOrAbove?: Maybe<Scalars['Boolean']['output']>;
  currentUserRole?: Maybe<Scalars['String']['output']>;
  currentUserRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fuelLevy?: Maybe<FuelLevy>;
  fuelLevyById?: Maybe<FuelLevy>;
  node?: Maybe<Node>;
  nodeId: Scalars['ID']['output'];
  parkPrice?: Maybe<ParkPrice>;
  parkPriceById?: Maybe<ParkPrice>;
  port?: Maybe<Port>;
  portById?: Maybe<Port>;
  portByName?: Maybe<Port>;
  query: Query;
  route?: Maybe<Route>;
  routeByCode?: Maybe<Route>;
  routeById?: Maybe<Route>;
  routePort?: Maybe<RoutePort>;
  routePortById?: Maybe<RoutePort>;
  routeVessel?: Maybe<RouteVessel>;
  routeVesselById?: Maybe<RouteVessel>;
  shipCompany?: Maybe<ShipCompany>;
  shipCompanyById?: Maybe<ShipCompany>;
  shipCompanyByName?: Maybe<ShipCompany>;
  state?: Maybe<State>;
  stateByCode?: Maybe<State>;
  suburb?: Maybe<Suburb>;
  suburbById?: Maybe<Suburb>;
  suburbByNameAndStateCodeAndPostcode?: Maybe<Suburb>;
  tollFee?: Maybe<TollFee>;
  tollFeeById?: Maybe<TollFee>;
  transportPrice?: Maybe<TransportPrice>;
  transportPriceById?: Maybe<TransportPrice>;
  truckCompany?: Maybe<TruckCompany>;
  truckCompanyById?: Maybe<TruckCompany>;
  user?: Maybe<User>;
  userByAuth0Id?: Maybe<User>;
  userById?: Maybe<User>;
  vessel?: Maybe<Vessel>;
  vesselById?: Maybe<Vessel>;
  wharfPrice?: Maybe<WharfPrice>;
  wharfPriceById?: Maybe<WharfPrice>;
};


export type QueryAddressArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryAddressByIdArgs = {
  id: Scalars['BigInt']['input'];
};


export type QueryAgentArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryAgentByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgentByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryAllAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AddressCondition>;
  filter?: InputMaybe<AddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};


export type QueryAllAgentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AgentCondition>;
  filter?: InputMaybe<AgentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AgentsOrderBy>>;
};


export type QueryAllBookingPricesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BookingPriceCondition>;
  filter?: InputMaybe<BookingPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BookingPricesOrderBy>>;
};


export type QueryAllBookingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BookingCondition>;
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};


export type QueryAllCountriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CountryCondition>;
  filter?: InputMaybe<CountryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};


export type QueryAllFuelLeviesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FuelLevyCondition>;
  filter?: InputMaybe<FuelLevyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FuelLeviesOrderBy>>;
};


export type QueryAllParkPricesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ParkPriceCondition>;
  filter?: InputMaybe<ParkPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParkPricesOrderBy>>;
};


export type QueryAllPortsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCondition>;
  filter?: InputMaybe<PortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortsOrderBy>>;
};


export type QueryAllRoutePortsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoutePortCondition>;
  filter?: InputMaybe<RoutePortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutePortsOrderBy>>;
};


export type QueryAllRouteVesselsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteVesselCondition>;
  filter?: InputMaybe<RouteVesselFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteVesselsOrderBy>>;
};


export type QueryAllRoutesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteCondition>;
  filter?: InputMaybe<RouteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};


export type QueryAllShipCompaniesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipCompanyCondition>;
  filter?: InputMaybe<ShipCompanyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipCompaniesOrderBy>>;
};


export type QueryAllStatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StateCondition>;
  filter?: InputMaybe<StateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatesOrderBy>>;
};


export type QueryAllSuburbsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuburbCondition>;
  filter?: InputMaybe<SuburbFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuburbsOrderBy>>;
};


export type QueryAllTollFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TollFeeCondition>;
  filter?: InputMaybe<TollFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TollFeesOrderBy>>;
};


export type QueryAllTransportPricesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TransportPriceCondition>;
  filter?: InputMaybe<TransportPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransportPricesOrderBy>>;
};


export type QueryAllTruckCompaniesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TruckCompanyCondition>;
  filter?: InputMaybe<TruckCompanyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TruckCompaniesOrderBy>>;
};


export type QueryAllUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type QueryAllVRouteEndpointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VRouteEndpointCondition>;
  filter?: InputMaybe<VRouteEndpointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VRouteEndpointsOrderBy>>;
};


export type QueryAllVesselsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselCondition>;
  filter?: InputMaybe<VesselFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};


export type QueryAllWharfPricesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WharfPriceCondition>;
  filter?: InputMaybe<WharfPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WharfPricesOrderBy>>;
};


export type QueryBookingArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryBookingByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBookingPriceArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryBookingPriceByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCountryArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryCountryByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCountryByIsoCode2Args = {
  isoCode2: Scalars['String']['input'];
};


export type QueryCountryByIsoCode3Args = {
  isoCode3: Scalars['String']['input'];
};


export type QueryCurrentUserHasRoleArgs = {
  roleName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFuelLevyArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryFuelLevyByIdArgs = {
  id: Scalars['BigInt']['input'];
};


export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryParkPriceArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryParkPriceByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryPortByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryRouteArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryRouteByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryRouteByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRoutePortArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryRoutePortByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRouteVesselArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryRouteVesselByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryShipCompanyArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryShipCompanyByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryShipCompanyByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryStateArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryStateByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QuerySuburbArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QuerySuburbByIdArgs = {
  id: Scalars['BigInt']['input'];
};


export type QuerySuburbByNameAndStateCodeAndPostcodeArgs = {
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
};


export type QueryTollFeeArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryTollFeeByIdArgs = {
  id: Scalars['BigInt']['input'];
};


export type QueryTransportPriceArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryTransportPriceByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTruckCompanyArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryTruckCompanyByIdArgs = {
  id: Scalars['BigInt']['input'];
};


export type QueryUserArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryUserByAuth0IdArgs = {
  auth0Id: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVesselArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryVesselByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWharfPriceArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryWharfPriceByIdArgs = {
  id: Scalars['Int']['input'];
};

export type Route = Node & {
  __typename?: 'Route';
  bookingsByRouteId: BookingsConnection;
  code: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  nodeId: Scalars['ID']['output'];
  routePortsByRouteId: RoutePortsConnection;
  routeVesselsByRouteId: RouteVesselsConnection;
  type?: Maybe<TradeDirection>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};


export type RouteBookingsByRouteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BookingCondition>;
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};


export type RouteRoutePortsByRouteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoutePortCondition>;
  filter?: InputMaybe<RoutePortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutePortsOrderBy>>;
};


export type RouteRouteVesselsByRouteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteVesselCondition>;
  filter?: InputMaybe<RouteVesselFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteVesselsOrderBy>>;
};

export type RouteCondition = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TradeDirection>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RouteFilter = {
  and?: InputMaybe<Array<RouteFilter>>;
  bookingsByRouteId?: InputMaybe<RouteToManyBookingFilter>;
  bookingsByRouteIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  not?: InputMaybe<RouteFilter>;
  or?: InputMaybe<Array<RouteFilter>>;
  routePortsByRouteId?: InputMaybe<RouteToManyRoutePortFilter>;
  routePortsByRouteIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  routeVesselsByRouteId?: InputMaybe<RouteToManyRouteVesselFilter>;
  routeVesselsByRouteIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<TradeDirectionFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type RouteInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TradeDirection>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RoutePatch = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TradeDirection>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RoutePort = Node & {
  __typename?: 'RoutePort';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  date?: Maybe<Scalars['Datetime']['output']>;
  dateType?: Maybe<DateType>;
  dow?: Maybe<Dow>;
  id: Scalars['Int']['output'];
  nodeId: Scalars['ID']['output'];
  portByPortId?: Maybe<Port>;
  portId?: Maybe<Scalars['Int']['output']>;
  portOrder?: Maybe<Scalars['Int']['output']>;
  routeByRouteId?: Maybe<Route>;
  routeId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type RoutePortCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Datetime']['input']>;
  dateType?: InputMaybe<DateType>;
  dow?: InputMaybe<Dow>;
  id?: InputMaybe<Scalars['Int']['input']>;
  portId?: InputMaybe<Scalars['Int']['input']>;
  portOrder?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RoutePortFilter = {
  and?: InputMaybe<Array<RoutePortFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DatetimeFilter>;
  dateType?: InputMaybe<DateTypeFilter>;
  dow?: InputMaybe<DowFilter>;
  id?: InputMaybe<IntFilter>;
  not?: InputMaybe<RoutePortFilter>;
  or?: InputMaybe<Array<RoutePortFilter>>;
  portByPortId?: InputMaybe<PortFilter>;
  portByPortIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  portId?: InputMaybe<IntFilter>;
  portOrder?: InputMaybe<IntFilter>;
  routeByRouteId?: InputMaybe<RouteFilter>;
  routeByRouteIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  routeId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type RoutePortInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Datetime']['input']>;
  dateType?: InputMaybe<DateType>;
  dow?: InputMaybe<Dow>;
  id?: InputMaybe<Scalars['Int']['input']>;
  portId?: InputMaybe<Scalars['Int']['input']>;
  portOrder?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RoutePortPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Datetime']['input']>;
  dateType?: InputMaybe<DateType>;
  dow?: InputMaybe<Dow>;
  id?: InputMaybe<Scalars['Int']['input']>;
  portId?: InputMaybe<Scalars['Int']['input']>;
  portOrder?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RoutePortsConnection = {
  __typename?: 'RoutePortsConnection';
  edges: Array<RoutePortsEdge>;
  nodes: Array<Maybe<RoutePort>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoutePortsEdge = {
  __typename?: 'RoutePortsEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<RoutePort>;
};

export enum RoutePortsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DateTypeAsc = 'DATE_TYPE_ASC',
  DateTypeDesc = 'DATE_TYPE_DESC',
  DowAsc = 'DOW_ASC',
  DowDesc = 'DOW_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PortIdAsc = 'PORT_ID_ASC',
  PortIdDesc = 'PORT_ID_DESC',
  PortOrderAsc = 'PORT_ORDER_ASC',
  PortOrderDesc = 'PORT_ORDER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RouteIdAsc = 'ROUTE_ID_ASC',
  RouteIdDesc = 'ROUTE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type RouteToManyBookingFilter = {
  every?: InputMaybe<BookingFilter>;
  none?: InputMaybe<BookingFilter>;
  some?: InputMaybe<BookingFilter>;
};

export type RouteToManyRoutePortFilter = {
  every?: InputMaybe<RoutePortFilter>;
  none?: InputMaybe<RoutePortFilter>;
  some?: InputMaybe<RoutePortFilter>;
};

export type RouteToManyRouteVesselFilter = {
  every?: InputMaybe<RouteVesselFilter>;
  none?: InputMaybe<RouteVesselFilter>;
  some?: InputMaybe<RouteVesselFilter>;
};

export type RouteVessel = Node & {
  __typename?: 'RouteVessel';
  bookingsByRouteVesselId: BookingsConnection;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  nodeId: Scalars['ID']['output'];
  routeByRouteId?: Maybe<Route>;
  routeId: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  vesselByVesselId?: Maybe<Vessel>;
  vesselId: Scalars['Int']['output'];
};


export type RouteVesselBookingsByRouteVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BookingCondition>;
  filter?: InputMaybe<BookingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};

export type RouteVesselCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteVesselFilter = {
  and?: InputMaybe<Array<RouteVesselFilter>>;
  bookingsByRouteVesselId?: InputMaybe<RouteVesselToManyBookingFilter>;
  bookingsByRouteVesselIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  not?: InputMaybe<RouteVesselFilter>;
  or?: InputMaybe<Array<RouteVesselFilter>>;
  routeByRouteId?: InputMaybe<RouteFilter>;
  routeId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  vesselByVesselId?: InputMaybe<VesselFilter>;
  vesselId?: InputMaybe<IntFilter>;
};

export type RouteVesselInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  routeId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId: Scalars['Int']['input'];
};

export type RouteVesselPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteVesselToManyBookingFilter = {
  every?: InputMaybe<BookingFilter>;
  none?: InputMaybe<BookingFilter>;
  some?: InputMaybe<BookingFilter>;
};

export type RouteVesselsConnection = {
  __typename?: 'RouteVesselsConnection';
  edges: Array<RouteVesselsEdge>;
  nodes: Array<Maybe<RouteVessel>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RouteVesselsEdge = {
  __typename?: 'RouteVesselsEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<RouteVessel>;
};

export enum RouteVesselsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RouteIdAsc = 'ROUTE_ID_ASC',
  RouteIdDesc = 'ROUTE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VesselIdAsc = 'VESSEL_ID_ASC',
  VesselIdDesc = 'VESSEL_ID_DESC'
}

export type RoutesConnection = {
  __typename?: 'RoutesConnection';
  edges: Array<RoutesEdge>;
  nodes: Array<Maybe<Route>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoutesEdge = {
  __typename?: 'RoutesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<Route>;
};

export enum RoutesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ShipCompaniesConnection = {
  __typename?: 'ShipCompaniesConnection';
  edges: Array<ShipCompaniesEdge>;
  nodes: Array<Maybe<ShipCompany>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ShipCompaniesEdge = {
  __typename?: 'ShipCompaniesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<ShipCompany>;
};

export enum ShipCompaniesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ShipCompany = Node & {
  __typename?: 'ShipCompany';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  vesselsByShipCompanyId: VesselsConnection;
};


export type ShipCompanyVesselsByShipCompanyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselCondition>;
  filter?: InputMaybe<VesselFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

export type ShipCompanyCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ShipCompanyFilter = {
  and?: InputMaybe<Array<ShipCompanyFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<ShipCompanyFilter>;
  or?: InputMaybe<Array<ShipCompanyFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  vesselsByShipCompanyId?: InputMaybe<ShipCompanyToManyVesselFilter>;
  vesselsByShipCompanyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipCompanyInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ShipCompanyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ShipCompanyToManyVesselFilter = {
  every?: InputMaybe<VesselFilter>;
  none?: InputMaybe<VesselFilter>;
  some?: InputMaybe<VesselFilter>;
};

export type State = Node & {
  __typename?: 'State';
  code: Scalars['String']['output'];
  countryByCountryId?: Maybe<Country>;
  countryId: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  parkPricesByStateId: ParkPricesConnection;
  suburbsByStateCode: SuburbsConnection;
  tollFeesByStateId: TollFeesConnection;
  wharfPricesByStateId: WharfPricesConnection;
};


export type StateParkPricesByStateIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ParkPriceCondition>;
  filter?: InputMaybe<ParkPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParkPricesOrderBy>>;
};


export type StateSuburbsByStateCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SuburbCondition>;
  filter?: InputMaybe<SuburbFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuburbsOrderBy>>;
};


export type StateTollFeesByStateIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TollFeeCondition>;
  filter?: InputMaybe<TollFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TollFeesOrderBy>>;
};


export type StateWharfPricesByStateIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WharfPriceCondition>;
  filter?: InputMaybe<WharfPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WharfPricesOrderBy>>;
};

export type StateCondition = {
  code?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StateFilter = {
  and?: InputMaybe<Array<StateFilter>>;
  code?: InputMaybe<StringFilter>;
  countryByCountryId?: InputMaybe<CountryFilter>;
  countryId?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<StateFilter>;
  or?: InputMaybe<Array<StateFilter>>;
  parkPricesByStateId?: InputMaybe<StateToManyParkPriceFilter>;
  parkPricesByStateIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  suburbsByStateCode?: InputMaybe<StateToManySuburbFilter>;
  suburbsByStateCodeExist?: InputMaybe<Scalars['Boolean']['input']>;
  tollFeesByStateId?: InputMaybe<StateToManyTollFeeFilter>;
  tollFeesByStateIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  wharfPricesByStateId?: InputMaybe<StateToManyWharfPriceFilter>;
  wharfPricesByStateIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StateInput = {
  code: Scalars['String']['input'];
  countryId: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
};

export type StatePatch = {
  code?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StateToManyParkPriceFilter = {
  every?: InputMaybe<ParkPriceFilter>;
  none?: InputMaybe<ParkPriceFilter>;
  some?: InputMaybe<ParkPriceFilter>;
};

export type StateToManySuburbFilter = {
  every?: InputMaybe<SuburbFilter>;
  none?: InputMaybe<SuburbFilter>;
  some?: InputMaybe<SuburbFilter>;
};

export type StateToManyTollFeeFilter = {
  every?: InputMaybe<TollFeeFilter>;
  none?: InputMaybe<TollFeeFilter>;
  some?: InputMaybe<TollFeeFilter>;
};

export type StateToManyWharfPriceFilter = {
  every?: InputMaybe<WharfPriceFilter>;
  none?: InputMaybe<WharfPriceFilter>;
  some?: InputMaybe<WharfPriceFilter>;
};

export type StatesConnection = {
  __typename?: 'StatesConnection';
  edges: Array<StatesEdge>;
  nodes: Array<Maybe<State>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StatesEdge = {
  __typename?: 'StatesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<State>;
};

export enum StatesOrderBy {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  CountryIdAsc = 'COUNTRY_ID_ASC',
  CountryIdDesc = 'COUNTRY_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type StringFilter = {
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  equalTo?: InputMaybe<Scalars['String']['input']>;
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  includes?: InputMaybe<Scalars['String']['input']>;
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  notLike?: InputMaybe<Scalars['String']['input']>;
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

export type StringListFilter = {
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Suburb = Node & {
  __typename?: 'Suburb';
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  postcode: Scalars['String']['output'];
  stateByStateCode?: Maybe<State>;
  stateCode: Scalars['String']['output'];
  transportPricesBySuburbId: TransportPricesConnection;
};


export type SuburbTransportPricesBySuburbIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TransportPriceCondition>;
  filter?: InputMaybe<TransportPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransportPricesOrderBy>>;
};

export type SuburbCondition = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type SuburbFilter = {
  and?: InputMaybe<Array<SuburbFilter>>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<SuburbFilter>;
  or?: InputMaybe<Array<SuburbFilter>>;
  postcode?: InputMaybe<StringFilter>;
  stateByStateCode?: InputMaybe<StateFilter>;
  stateCode?: InputMaybe<StringFilter>;
  transportPricesBySuburbId?: InputMaybe<SuburbToManyTransportPriceFilter>;
  transportPricesBySuburbIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuburbInput = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
};

export type SuburbPatch = {
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type SuburbToManyTransportPriceFilter = {
  every?: InputMaybe<TransportPriceFilter>;
  none?: InputMaybe<TransportPriceFilter>;
  some?: InputMaybe<TransportPriceFilter>;
};

export type SuburbsConnection = {
  __typename?: 'SuburbsConnection';
  edges: Array<SuburbsEdge>;
  nodes: Array<Maybe<Suburb>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SuburbsEdge = {
  __typename?: 'SuburbsEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<Suburb>;
};

export enum SuburbsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PostcodeAsc = 'POSTCODE_ASC',
  PostcodeDesc = 'POSTCODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateCodeAsc = 'STATE_CODE_ASC',
  StateCodeDesc = 'STATE_CODE_DESC'
}

export type TollFee = Node & {
  __typename?: 'TollFee';
  companyId?: Maybe<Scalars['BigInt']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  fee?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['BigInt']['output'];
  nodeId: Scalars['ID']['output'];
  stateByStateId?: Maybe<State>;
  stateId?: Maybe<Scalars['String']['output']>;
  truckCompanyByCompanyId?: Maybe<TruckCompany>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  validFrom?: Maybe<Scalars['Datetime']['output']>;
  validTo?: Maybe<Scalars['Datetime']['output']>;
};

export type TollFeeCondition = {
  companyId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TollFeeFilter = {
  and?: InputMaybe<Array<TollFeeFilter>>;
  companyId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  not?: InputMaybe<TollFeeFilter>;
  or?: InputMaybe<Array<TollFeeFilter>>;
  stateByStateId?: InputMaybe<StateFilter>;
  stateByStateIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  stateId?: InputMaybe<StringFilter>;
  truckCompanyByCompanyId?: InputMaybe<TruckCompanyFilter>;
  truckCompanyByCompanyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  validFrom?: InputMaybe<DatetimeFilter>;
  validTo?: InputMaybe<DatetimeFilter>;
};

export type TollFeeInput = {
  companyId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TollFeePatch = {
  companyId?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TollFeesConnection = {
  __typename?: 'TollFeesConnection';
  edges: Array<TollFeesEdge>;
  nodes: Array<Maybe<TollFee>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TollFeesEdge = {
  __typename?: 'TollFeesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<TollFee>;
};

export enum TollFeesOrderBy {
  CompanyIdAsc = 'COMPANY_ID_ASC',
  CompanyIdDesc = 'COMPANY_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateIdAsc = 'STATE_ID_ASC',
  StateIdDesc = 'STATE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValidFromAsc = 'VALID_FROM_ASC',
  ValidFromDesc = 'VALID_FROM_DESC',
  ValidToAsc = 'VALID_TO_ASC',
  ValidToDesc = 'VALID_TO_DESC'
}

export enum TradeDirection {
  Export = 'EXPORT',
  Import = 'IMPORT'
}

export type TradeDirectionFilter = {
  distinctFrom?: InputMaybe<TradeDirection>;
  equalTo?: InputMaybe<TradeDirection>;
  greaterThan?: InputMaybe<TradeDirection>;
  greaterThanOrEqualTo?: InputMaybe<TradeDirection>;
  in?: InputMaybe<Array<TradeDirection>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<TradeDirection>;
  lessThanOrEqualTo?: InputMaybe<TradeDirection>;
  notDistinctFrom?: InputMaybe<TradeDirection>;
  notEqualTo?: InputMaybe<TradeDirection>;
  notIn?: InputMaybe<Array<TradeDirection>>;
};

export type TransportPrice = Node & {
  __typename?: 'TransportPrice';
  containerType?: Maybe<ContainerSizeEnum>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  liftCharge?: Maybe<Scalars['BigFloat']['output']>;
  nodeId: Scalars['ID']['output'];
  price?: Maybe<Scalars['BigFloat']['output']>;
  sideLoadCharge?: Maybe<Scalars['BigFloat']['output']>;
  suburbBySuburbId?: Maybe<Suburb>;
  suburbId?: Maybe<Scalars['Int']['output']>;
  truckCompanyByTruckCompanyId?: Maybe<TruckCompany>;
  truckCompanyId?: Maybe<Scalars['Int']['output']>;
  unloadMethod?: Maybe<UnloadMethod>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  validFrom?: Maybe<Scalars['Datetime']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type TransportPriceCondition = {
  containerType?: InputMaybe<ContainerSizeEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  liftCharge?: InputMaybe<Scalars['BigFloat']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  sideLoadCharge?: InputMaybe<Scalars['BigFloat']['input']>;
  suburbId?: InputMaybe<Scalars['Int']['input']>;
  truckCompanyId?: InputMaybe<Scalars['Int']['input']>;
  unloadMethod?: InputMaybe<UnloadMethod>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type TransportPriceFilter = {
  and?: InputMaybe<Array<TransportPriceFilter>>;
  containerType?: InputMaybe<ContainerSizeEnumFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  liftCharge?: InputMaybe<BigFloatFilter>;
  not?: InputMaybe<TransportPriceFilter>;
  or?: InputMaybe<Array<TransportPriceFilter>>;
  price?: InputMaybe<BigFloatFilter>;
  sideLoadCharge?: InputMaybe<BigFloatFilter>;
  suburbBySuburbId?: InputMaybe<SuburbFilter>;
  suburbBySuburbIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  suburbId?: InputMaybe<IntFilter>;
  truckCompanyByTruckCompanyId?: InputMaybe<TruckCompanyFilter>;
  truckCompanyByTruckCompanyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  truckCompanyId?: InputMaybe<IntFilter>;
  unloadMethod?: InputMaybe<UnloadMethodFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  validFrom?: InputMaybe<DatetimeFilter>;
  validTo?: InputMaybe<DateFilter>;
};

export type TransportPriceInput = {
  containerType?: InputMaybe<ContainerSizeEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  liftCharge?: InputMaybe<Scalars['BigFloat']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  sideLoadCharge?: InputMaybe<Scalars['BigFloat']['input']>;
  suburbId?: InputMaybe<Scalars['Int']['input']>;
  truckCompanyId?: InputMaybe<Scalars['Int']['input']>;
  unloadMethod?: InputMaybe<UnloadMethod>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type TransportPricePatch = {
  containerType?: InputMaybe<ContainerSizeEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  liftCharge?: InputMaybe<Scalars['BigFloat']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  sideLoadCharge?: InputMaybe<Scalars['BigFloat']['input']>;
  suburbId?: InputMaybe<Scalars['Int']['input']>;
  truckCompanyId?: InputMaybe<Scalars['Int']['input']>;
  unloadMethod?: InputMaybe<UnloadMethod>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type TransportPricesConnection = {
  __typename?: 'TransportPricesConnection';
  edges: Array<TransportPricesEdge>;
  nodes: Array<Maybe<TransportPrice>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TransportPricesEdge = {
  __typename?: 'TransportPricesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<TransportPrice>;
};

export enum TransportPricesOrderBy {
  ContainerTypeAsc = 'CONTAINER_TYPE_ASC',
  ContainerTypeDesc = 'CONTAINER_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LiftChargeAsc = 'LIFT_CHARGE_ASC',
  LiftChargeDesc = 'LIFT_CHARGE_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SideLoadChargeAsc = 'SIDE_LOAD_CHARGE_ASC',
  SideLoadChargeDesc = 'SIDE_LOAD_CHARGE_DESC',
  SuburbIdAsc = 'SUBURB_ID_ASC',
  SuburbIdDesc = 'SUBURB_ID_DESC',
  TruckCompanyIdAsc = 'TRUCK_COMPANY_ID_ASC',
  TruckCompanyIdDesc = 'TRUCK_COMPANY_ID_DESC',
  UnloadMethodAsc = 'UNLOAD_METHOD_ASC',
  UnloadMethodDesc = 'UNLOAD_METHOD_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValidFromAsc = 'VALID_FROM_ASC',
  ValidFromDesc = 'VALID_FROM_DESC',
  ValidToAsc = 'VALID_TO_ASC',
  ValidToDesc = 'VALID_TO_DESC'
}

export type TruckCompaniesConnection = {
  __typename?: 'TruckCompaniesConnection';
  edges: Array<TruckCompaniesEdge>;
  nodes: Array<Maybe<TruckCompany>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TruckCompaniesEdge = {
  __typename?: 'TruckCompaniesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<TruckCompany>;
};

export enum TruckCompaniesOrderBy {
  AbnAsc = 'ABN_ASC',
  AbnDesc = 'ABN_DESC',
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  ExtraChargeAsc = 'EXTRA_CHARGE_ASC',
  ExtraChargeDesc = 'EXTRA_CHARGE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type TruckCompany = Node & {
  __typename?: 'TruckCompany';
  abn?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  email?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  extraCharge?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  parkPricesByCompanyId: ParkPricesConnection;
  phone?: Maybe<Scalars['String']['output']>;
  tollFeesByCompanyId: TollFeesConnection;
  transportPricesByTruckCompanyId: TransportPricesConnection;
  updatedAt: Scalars['Datetime']['output'];
  wharfPricesByTruckCompanyId: WharfPricesConnection;
};


export type TruckCompanyParkPricesByCompanyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ParkPriceCondition>;
  filter?: InputMaybe<ParkPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParkPricesOrderBy>>;
};


export type TruckCompanyTollFeesByCompanyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TollFeeCondition>;
  filter?: InputMaybe<TollFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TollFeesOrderBy>>;
};


export type TruckCompanyTransportPricesByTruckCompanyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TransportPriceCondition>;
  filter?: InputMaybe<TransportPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransportPricesOrderBy>>;
};


export type TruckCompanyWharfPricesByTruckCompanyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WharfPriceCondition>;
  filter?: InputMaybe<WharfPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WharfPricesOrderBy>>;
};

export type TruckCompanyCondition = {
  abn?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  extraCharge?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TruckCompanyFilter = {
  abn?: InputMaybe<StringFilter>;
  address?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<TruckCompanyFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringListFilter>;
  extraCharge?: InputMaybe<JsonFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<TruckCompanyFilter>;
  note?: InputMaybe<StringFilter>;
  or?: InputMaybe<Array<TruckCompanyFilter>>;
  parkPricesByCompanyId?: InputMaybe<TruckCompanyToManyParkPriceFilter>;
  parkPricesByCompanyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<StringFilter>;
  tollFeesByCompanyId?: InputMaybe<TruckCompanyToManyTollFeeFilter>;
  tollFeesByCompanyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  transportPricesByTruckCompanyId?: InputMaybe<TruckCompanyToManyTransportPriceFilter>;
  transportPricesByTruckCompanyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  wharfPricesByTruckCompanyId?: InputMaybe<TruckCompanyToManyWharfPriceFilter>;
  wharfPricesByTruckCompanyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TruckCompanyInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  extraCharge?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TruckCompanyPatch = {
  abn?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  extraCharge?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['BigInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type TruckCompanyToManyParkPriceFilter = {
  every?: InputMaybe<ParkPriceFilter>;
  none?: InputMaybe<ParkPriceFilter>;
  some?: InputMaybe<ParkPriceFilter>;
};

export type TruckCompanyToManyTollFeeFilter = {
  every?: InputMaybe<TollFeeFilter>;
  none?: InputMaybe<TollFeeFilter>;
  some?: InputMaybe<TollFeeFilter>;
};

export type TruckCompanyToManyTransportPriceFilter = {
  every?: InputMaybe<TransportPriceFilter>;
  none?: InputMaybe<TransportPriceFilter>;
  some?: InputMaybe<TransportPriceFilter>;
};

export type TruckCompanyToManyWharfPriceFilter = {
  every?: InputMaybe<WharfPriceFilter>;
  none?: InputMaybe<WharfPriceFilter>;
  some?: InputMaybe<WharfPriceFilter>;
};

export enum UnloadMethod {
  Sidelift = 'SIDELIFT',
  Trailer = 'TRAILER'
}

export type UnloadMethodFilter = {
  distinctFrom?: InputMaybe<UnloadMethod>;
  equalTo?: InputMaybe<UnloadMethod>;
  greaterThan?: InputMaybe<UnloadMethod>;
  greaterThanOrEqualTo?: InputMaybe<UnloadMethod>;
  in?: InputMaybe<Array<UnloadMethod>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<UnloadMethod>;
  lessThanOrEqualTo?: InputMaybe<UnloadMethod>;
  notDistinctFrom?: InputMaybe<UnloadMethod>;
  notEqualTo?: InputMaybe<UnloadMethod>;
  notIn?: InputMaybe<Array<UnloadMethod>>;
};

export type UpdateAddressByIdInput = {
  addressPatch: AddressPatch;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
};

export type UpdateAddressInput = {
  addressPatch: AddressPatch;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type UpdateAddressPayload = {
  __typename?: 'UpdateAddressPayload';
  address?: Maybe<Address>;
  addressEdge?: Maybe<AddressesEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  query?: Maybe<Query>;
};


export type UpdateAddressPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
};

export type UpdateAgentByIdInput = {
  agentPatch: AgentPatch;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateAgentByNameInput = {
  agentPatch: AgentPatch;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateAgentInput = {
  agentPatch: AgentPatch;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type UpdateAgentPayload = {
  __typename?: 'UpdateAgentPayload';
  agent?: Maybe<Agent>;
  agentEdge?: Maybe<AgentsEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  query?: Maybe<Query>;
};


export type UpdateAgentPayloadAgentEdgeArgs = {
  orderBy?: InputMaybe<Array<AgentsOrderBy>>;
};

export type UpdateBookingByIdInput = {
  bookingPatch: BookingPatch;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateBookingInput = {
  bookingPatch: BookingPatch;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type UpdateBookingPayload = {
  __typename?: 'UpdateBookingPayload';
  agentByAgentId?: Maybe<Agent>;
  booking?: Maybe<Booking>;
  bookingEdge?: Maybe<BookingsEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  portByDischargePort?: Maybe<Port>;
  portByPod?: Maybe<Port>;
  portByPol?: Maybe<Port>;
  query?: Maybe<Query>;
  routeByRouteId?: Maybe<Route>;
  routeVesselByRouteVesselId?: Maybe<RouteVessel>;
};


export type UpdateBookingPayloadBookingEdgeArgs = {
  orderBy?: InputMaybe<Array<BookingsOrderBy>>;
};

export type UpdateBookingPriceByIdInput = {
  bookingPricePatch: BookingPricePatch;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateBookingPriceInput = {
  bookingPricePatch: BookingPricePatch;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
};

export type UpdateBookingPricePayload = {
  __typename?: 'UpdateBookingPricePayload';
  bookingByBookingId?: Maybe<Booking>;
  bookingPrice?: Maybe<BookingPrice>;
  bookingPriceEdge?: Maybe<BookingPricesEdge>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
};


export type UpdateBookingPricePayloadBookingPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<BookingPricesOrderBy>>;
};

export type UpdateCountryByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryPatch: CountryPatch;
  id: Scalars['Int']['input'];
};

export type UpdateCountryByIsoCode2Input = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryPatch: CountryPatch;
  isoCode2: Scalars['String']['input'];
};

export type UpdateCountryByIsoCode3Input = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryPatch: CountryPatch;
  isoCode3: Scalars['String']['input'];
};

export type UpdateCountryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryPatch: CountryPatch;
  nodeId: Scalars['ID']['input'];
};

export type UpdateCountryPayload = {
  __typename?: 'UpdateCountryPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryEdge?: Maybe<CountriesEdge>;
  query?: Maybe<Query>;
};


export type UpdateCountryPayloadCountryEdgeArgs = {
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};

export type UpdateFuelLevyByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fuelLevyPatch: FuelLevyPatch;
  id: Scalars['BigInt']['input'];
};

export type UpdateFuelLevyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fuelLevyPatch: FuelLevyPatch;
  nodeId: Scalars['ID']['input'];
};

export type UpdateFuelLevyPayload = {
  __typename?: 'UpdateFuelLevyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  fuelLevy?: Maybe<FuelLevy>;
  fuelLevyEdge?: Maybe<FuelLeviesEdge>;
  query?: Maybe<Query>;
};


export type UpdateFuelLevyPayloadFuelLevyEdgeArgs = {
  orderBy?: InputMaybe<Array<FuelLeviesOrderBy>>;
};

export type UpdateParkPriceByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  parkPricePatch: ParkPricePatch;
};

export type UpdateParkPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  parkPricePatch: ParkPricePatch;
};

export type UpdateParkPricePayload = {
  __typename?: 'UpdateParkPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  parkPrice?: Maybe<ParkPrice>;
  parkPriceEdge?: Maybe<ParkPricesEdge>;
  query?: Maybe<Query>;
  stateByStateId?: Maybe<State>;
  truckCompanyByCompanyId?: Maybe<TruckCompany>;
};


export type UpdateParkPricePayloadParkPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<ParkPricesOrderBy>>;
};

export type UpdatePortByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  portPatch: PortPatch;
};

export type UpdatePortByNameInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  portPatch: PortPatch;
};

export type UpdatePortInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  portPatch: PortPatch;
};

export type UpdatePortPayload = {
  __typename?: 'UpdatePortPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  port?: Maybe<Port>;
  portEdge?: Maybe<PortsEdge>;
  query?: Maybe<Query>;
};


export type UpdatePortPayloadPortEdgeArgs = {
  orderBy?: InputMaybe<Array<PortsOrderBy>>;
};

export type UpdateRouteByCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  routePatch: RoutePatch;
};

export type UpdateRouteByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  routePatch: RoutePatch;
};

export type UpdateRouteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  routePatch: RoutePatch;
};

export type UpdateRoutePayload = {
  __typename?: 'UpdateRoutePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  route?: Maybe<Route>;
  routeEdge?: Maybe<RoutesEdge>;
};


export type UpdateRoutePayloadRouteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};

export type UpdateRoutePortByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  routePortPatch: RoutePortPatch;
};

export type UpdateRoutePortInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  routePortPatch: RoutePortPatch;
};

export type UpdateRoutePortPayload = {
  __typename?: 'UpdateRoutePortPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  portByPortId?: Maybe<Port>;
  query?: Maybe<Query>;
  routeByRouteId?: Maybe<Route>;
  routePort?: Maybe<RoutePort>;
  routePortEdge?: Maybe<RoutePortsEdge>;
};


export type UpdateRoutePortPayloadRoutePortEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutePortsOrderBy>>;
};

export type UpdateRouteVesselByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  routeVesselPatch: RouteVesselPatch;
};

export type UpdateRouteVesselInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  routeVesselPatch: RouteVesselPatch;
};

export type UpdateRouteVesselPayload = {
  __typename?: 'UpdateRouteVesselPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  routeByRouteId?: Maybe<Route>;
  routeVessel?: Maybe<RouteVessel>;
  routeVesselEdge?: Maybe<RouteVesselsEdge>;
  vesselByVesselId?: Maybe<Vessel>;
};


export type UpdateRouteVesselPayloadRouteVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<RouteVesselsOrderBy>>;
};

export type UpdateShipCompanyByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  shipCompanyPatch: ShipCompanyPatch;
};

export type UpdateShipCompanyByNameInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shipCompanyPatch: ShipCompanyPatch;
};

export type UpdateShipCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  shipCompanyPatch: ShipCompanyPatch;
};

export type UpdateShipCompanyPayload = {
  __typename?: 'UpdateShipCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  shipCompany?: Maybe<ShipCompany>;
  shipCompanyEdge?: Maybe<ShipCompaniesEdge>;
};


export type UpdateShipCompanyPayloadShipCompanyEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipCompaniesOrderBy>>;
};

export type UpdateStateByCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  statePatch: StatePatch;
};

export type UpdateStateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  statePatch: StatePatch;
};

export type UpdateStatePayload = {
  __typename?: 'UpdateStatePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryByCountryId?: Maybe<Country>;
  query?: Maybe<Query>;
  state?: Maybe<State>;
  stateEdge?: Maybe<StatesEdge>;
};


export type UpdateStatePayloadStateEdgeArgs = {
  orderBy?: InputMaybe<Array<StatesOrderBy>>;
};

export type UpdateSuburbByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  suburbPatch: SuburbPatch;
};

export type UpdateSuburbByNameAndStateCodeAndPostcodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
  suburbPatch: SuburbPatch;
};

export type UpdateSuburbInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  suburbPatch: SuburbPatch;
};

export type UpdateSuburbPayload = {
  __typename?: 'UpdateSuburbPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  stateByStateCode?: Maybe<State>;
  suburb?: Maybe<Suburb>;
  suburbEdge?: Maybe<SuburbsEdge>;
};


export type UpdateSuburbPayloadSuburbEdgeArgs = {
  orderBy?: InputMaybe<Array<SuburbsOrderBy>>;
};

export type UpdateTollFeeByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  tollFeePatch: TollFeePatch;
};

export type UpdateTollFeeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  tollFeePatch: TollFeePatch;
};

export type UpdateTollFeePayload = {
  __typename?: 'UpdateTollFeePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  stateByStateId?: Maybe<State>;
  tollFee?: Maybe<TollFee>;
  tollFeeEdge?: Maybe<TollFeesEdge>;
  truckCompanyByCompanyId?: Maybe<TruckCompany>;
};


export type UpdateTollFeePayloadTollFeeEdgeArgs = {
  orderBy?: InputMaybe<Array<TollFeesOrderBy>>;
};

export type UpdateTransportPriceByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  transportPricePatch: TransportPricePatch;
};

export type UpdateTransportPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  transportPricePatch: TransportPricePatch;
};

export type UpdateTransportPricePayload = {
  __typename?: 'UpdateTransportPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  suburbBySuburbId?: Maybe<Suburb>;
  transportPrice?: Maybe<TransportPrice>;
  transportPriceEdge?: Maybe<TransportPricesEdge>;
  truckCompanyByTruckCompanyId?: Maybe<TruckCompany>;
};


export type UpdateTransportPricePayloadTransportPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<TransportPricesOrderBy>>;
};

export type UpdateTruckCompanyByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BigInt']['input'];
  truckCompanyPatch: TruckCompanyPatch;
};

export type UpdateTruckCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  truckCompanyPatch: TruckCompanyPatch;
};

export type UpdateTruckCompanyPayload = {
  __typename?: 'UpdateTruckCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  truckCompany?: Maybe<TruckCompany>;
  truckCompanyEdge?: Maybe<TruckCompaniesEdge>;
};


export type UpdateTruckCompanyPayloadTruckCompanyEdgeArgs = {
  orderBy?: InputMaybe<Array<TruckCompaniesOrderBy>>;
};

export type UpdateUserByAuth0IdInput = {
  auth0Id: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userPatch: UserPatch;
};

export type UpdateUserByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  userPatch: UserPatch;
};

export type UpdateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  userPatch: UserPatch;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  user?: Maybe<User>;
  userEdge?: Maybe<UsersEdge>;
};


export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type UpdateVesselByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  vesselPatch: VesselPatch;
};

export type UpdateVesselInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  vesselPatch: VesselPatch;
};

export type UpdateVesselPayload = {
  __typename?: 'UpdateVesselPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  shipCompanyByShipCompanyId?: Maybe<ShipCompany>;
  vessel?: Maybe<Vessel>;
  vesselEdge?: Maybe<VesselsEdge>;
};


export type UpdateVesselPayloadVesselEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselsOrderBy>>;
};

export type UpdateWharfPriceByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  wharfPricePatch: WharfPricePatch;
};

export type UpdateWharfPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['ID']['input'];
  wharfPricePatch: WharfPricePatch;
};

export type UpdateWharfPricePayload = {
  __typename?: 'UpdateWharfPricePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  stateByStateId?: Maybe<State>;
  truckCompanyByTruckCompanyId?: Maybe<TruckCompany>;
  wharfPrice?: Maybe<WharfPrice>;
  wharfPriceEdge?: Maybe<WharfPricesEdge>;
};


export type UpdateWharfPricePayloadWharfPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<WharfPricesOrderBy>>;
};

export type User = Node & {
  __typename?: 'User';
  auth0Id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nodeId: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type UserCondition = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type UserFilter = {
  and?: InputMaybe<Array<UserFilter>>;
  auth0Id?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<UserFilter>;
  or?: InputMaybe<Array<UserFilter>>;
  role?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type UserInput = {
  auth0Id: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type UserPatch = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UsersEdge>;
  nodes: Array<Maybe<User>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UsersEdge = {
  __typename?: 'UsersEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<User>;
};

export enum UsersOrderBy {
  Auth0IdAsc = 'AUTH0_ID_ASC',
  Auth0IdDesc = 'AUTH0_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type VRouteEndpoint = {
  __typename?: 'VRouteEndpoint';
  podId?: Maybe<Scalars['Int']['output']>;
  polId?: Maybe<Scalars['Int']['output']>;
  routeId?: Maybe<Scalars['Int']['output']>;
};

export type VRouteEndpointCondition = {
  podId?: InputMaybe<Scalars['Int']['input']>;
  polId?: InputMaybe<Scalars['Int']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
};

export type VRouteEndpointFilter = {
  and?: InputMaybe<Array<VRouteEndpointFilter>>;
  not?: InputMaybe<VRouteEndpointFilter>;
  or?: InputMaybe<Array<VRouteEndpointFilter>>;
  podId?: InputMaybe<IntFilter>;
  polId?: InputMaybe<IntFilter>;
  routeId?: InputMaybe<IntFilter>;
};

export type VRouteEndpointsConnection = {
  __typename?: 'VRouteEndpointsConnection';
  edges: Array<VRouteEndpointsEdge>;
  nodes: Array<Maybe<VRouteEndpoint>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VRouteEndpointsEdge = {
  __typename?: 'VRouteEndpointsEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<VRouteEndpoint>;
};

export enum VRouteEndpointsOrderBy {
  Natural = 'NATURAL',
  PodIdAsc = 'POD_ID_ASC',
  PodIdDesc = 'POD_ID_DESC',
  PolIdAsc = 'POL_ID_ASC',
  PolIdDesc = 'POL_ID_DESC',
  RouteIdAsc = 'ROUTE_ID_ASC',
  RouteIdDesc = 'ROUTE_ID_DESC'
}

export type Vessel = Node & {
  __typename?: 'Vessel';
  id: Scalars['Int']['output'];
  imo?: Maybe<Scalars['Int']['output']>;
  mmsi?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  routeVesselsByVesselId: RouteVesselsConnection;
  shipCompanyByShipCompanyId?: Maybe<ShipCompany>;
  shipCompanyId?: Maybe<Scalars['Int']['output']>;
};


export type VesselRouteVesselsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteVesselCondition>;
  filter?: InputMaybe<RouteVesselFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteVesselsOrderBy>>;
};

export type VesselCondition = {
  id?: InputMaybe<Scalars['Int']['input']>;
  imo?: InputMaybe<Scalars['Int']['input']>;
  mmsi?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shipCompanyId?: InputMaybe<Scalars['Int']['input']>;
};

export type VesselFilter = {
  and?: InputMaybe<Array<VesselFilter>>;
  id?: InputMaybe<IntFilter>;
  imo?: InputMaybe<IntFilter>;
  mmsi?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<VesselFilter>;
  or?: InputMaybe<Array<VesselFilter>>;
  routeVesselsByVesselId?: InputMaybe<VesselToManyRouteVesselFilter>;
  routeVesselsByVesselIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  shipCompanyByShipCompanyId?: InputMaybe<ShipCompanyFilter>;
  shipCompanyByShipCompanyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  shipCompanyId?: InputMaybe<IntFilter>;
};

export type VesselInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  imo?: InputMaybe<Scalars['Int']['input']>;
  mmsi?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  shipCompanyId?: InputMaybe<Scalars['Int']['input']>;
};

export type VesselPatch = {
  id?: InputMaybe<Scalars['Int']['input']>;
  imo?: InputMaybe<Scalars['Int']['input']>;
  mmsi?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shipCompanyId?: InputMaybe<Scalars['Int']['input']>;
};

export type VesselToManyRouteVesselFilter = {
  every?: InputMaybe<RouteVesselFilter>;
  none?: InputMaybe<RouteVesselFilter>;
  some?: InputMaybe<RouteVesselFilter>;
};

export type VesselsConnection = {
  __typename?: 'VesselsConnection';
  edges: Array<VesselsEdge>;
  nodes: Array<Maybe<Vessel>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VesselsEdge = {
  __typename?: 'VesselsEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<Vessel>;
};

export enum VesselsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ImoAsc = 'IMO_ASC',
  ImoDesc = 'IMO_DESC',
  MmsiAsc = 'MMSI_ASC',
  MmsiDesc = 'MMSI_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShipCompanyIdAsc = 'SHIP_COMPANY_ID_ASC',
  ShipCompanyIdDesc = 'SHIP_COMPANY_ID_DESC'
}

export type WharfPrice = Node & {
  __typename?: 'WharfPrice';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  nodeId: Scalars['ID']['output'];
  price?: Maybe<Scalars['BigFloat']['output']>;
  stateByStateId?: Maybe<State>;
  stateId?: Maybe<Scalars['String']['output']>;
  tradeDirection?: Maybe<TradeDirection>;
  truckCompanyByTruckCompanyId?: Maybe<TruckCompany>;
  truckCompanyId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Datetime']['output']>;
  wharfName?: Maybe<Scalars['String']['output']>;
};

export type WharfPriceCondition = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  tradeDirection?: InputMaybe<TradeDirection>;
  truckCompanyId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
  wharfName?: InputMaybe<Scalars['String']['input']>;
};

export type WharfPriceFilter = {
  and?: InputMaybe<Array<WharfPriceFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<IntFilter>;
  not?: InputMaybe<WharfPriceFilter>;
  or?: InputMaybe<Array<WharfPriceFilter>>;
  price?: InputMaybe<BigFloatFilter>;
  stateByStateId?: InputMaybe<StateFilter>;
  stateByStateIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  stateId?: InputMaybe<StringFilter>;
  tradeDirection?: InputMaybe<TradeDirectionFilter>;
  truckCompanyByTruckCompanyId?: InputMaybe<TruckCompanyFilter>;
  truckCompanyByTruckCompanyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  truckCompanyId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  validFrom?: InputMaybe<DateFilter>;
  validTo?: InputMaybe<DatetimeFilter>;
  wharfName?: InputMaybe<StringFilter>;
};

export type WharfPriceInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  tradeDirection?: InputMaybe<TradeDirection>;
  truckCompanyId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
  wharfName?: InputMaybe<Scalars['String']['input']>;
};

export type WharfPricePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  tradeDirection?: InputMaybe<TradeDirection>;
  truckCompanyId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
  wharfName?: InputMaybe<Scalars['String']['input']>;
};

export type WharfPricesConnection = {
  __typename?: 'WharfPricesConnection';
  edges: Array<WharfPricesEdge>;
  nodes: Array<Maybe<WharfPrice>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WharfPricesEdge = {
  __typename?: 'WharfPricesEdge';
  cursor?: Maybe<Scalars['Cursor']['output']>;
  node?: Maybe<WharfPrice>;
};

export enum WharfPricesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateIdAsc = 'STATE_ID_ASC',
  StateIdDesc = 'STATE_ID_DESC',
  TradeDirectionAsc = 'TRADE_DIRECTION_ASC',
  TradeDirectionDesc = 'TRADE_DIRECTION_DESC',
  TruckCompanyIdAsc = 'TRUCK_COMPANY_ID_ASC',
  TruckCompanyIdDesc = 'TRUCK_COMPANY_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValidFromAsc = 'VALID_FROM_ASC',
  ValidFromDesc = 'VALID_FROM_DESC',
  ValidToAsc = 'VALID_TO_ASC',
  ValidToDesc = 'VALID_TO_DESC',
  WharfNameAsc = 'WHARF_NAME_ASC',
  WharfNameDesc = 'WHARF_NAME_DESC'
}

export type AgentFragmentFragment = { __typename?: 'Agent', id: number, name: string };

export type BookingPriceFragmentFragment = { __typename?: 'BookingPrice', id: number, containerSize?: ContainerSizeEnum | undefined, cost?: any | undefined, bookingId?: number | undefined };

export type RouteFragmentFragment = { __typename?: 'Route', id: number, code: string, type?: TradeDirection | undefined, description?: string | undefined, routePortsByRouteId: { __typename?: 'RoutePortsConnection', totalCount: number, nodes: Array<{ __typename?: 'RoutePort', date?: any | undefined, dow?: Dow | undefined, dateType?: DateType | undefined, portOrder?: number | undefined, portByPortId?: { __typename?: 'Port', id: number, name: string, countryId?: number | undefined } | undefined } | undefined> } };

export type VesselFragmentFragment = { __typename?: 'Vessel', id: number, name: string };

export type CreateAgentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  abn?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateAgentMutation = { __typename?: 'Mutation', createAgent?: { __typename?: 'CreateAgentPayload', clientMutationId?: string | undefined } | undefined };

export type CreateBookingMutationVariables = Exact<{
  agentId: Scalars['Int']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  etd: Scalars['Date']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['Int']['input'];
  pod?: InputMaybe<Scalars['Int']['input']>;
  pol?: InputMaybe<Scalars['Int']['input']>;
  dischargePort?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking?: { __typename?: 'CreateBookingPayload', clientMutationId?: string | undefined, booking?: { __typename?: 'Booking', id: number, etd?: any | undefined, currency: string, remark?: string | undefined, routeId?: number | undefined, routeByRouteId?: { __typename?: 'Route', id: number, code: string, routeVesselsByRouteId: { __typename?: 'RouteVesselsConnection', nodes: Array<{ __typename?: 'RouteVessel', vesselByVesselId?: { __typename?: 'Vessel', id: number, name: string, shipCompanyByShipCompanyId?: { __typename?: 'ShipCompany', id: number, name: string } | undefined } | undefined } | undefined> } } | undefined, agentByAgentId?: { __typename?: 'Agent', id: number, name: string } | undefined, portByPod?: { __typename?: 'Port', id: number, name: string } | undefined, portByPol?: { __typename?: 'Port', id: number, name: string } | undefined, portByDischargePort?: { __typename?: 'Port', id: number, name: string } | undefined, bookingPricesByBookingId: { __typename?: 'BookingPricesConnection', nodes: Array<{ __typename?: 'BookingPrice', containerSize?: ContainerSizeEnum | undefined, cost?: any | undefined, id: number } | undefined> } } | undefined } | undefined };

export type CreateFuelLevyMutationVariables = Exact<{
  truckCompanyId: Scalars['BigInt']['input'];
  levy?: InputMaybe<Scalars['BigFloat']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
}>;


export type CreateFuelLevyMutation = { __typename?: 'Mutation', createFuelLevy?: { __typename?: 'CreateFuelLevyPayload', clientMutationId?: string | undefined } | undefined };

export type CreateParkPriceMutationVariables = Exact<{
  companyId: Scalars['BigInt']['input'];
  stateId?: InputMaybe<Scalars['String']['input']>;
  parkName?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CreateParkPriceMutation = { __typename?: 'Mutation', createParkPrice?: { __typename?: 'CreateParkPricePayload', clientMutationId?: string | undefined } | undefined };

export type CreatePortMutationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  countryId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreatePortMutationMutation = { __typename?: 'Mutation', createPort?: { __typename?: 'CreatePortPayload', clientMutationId?: string | undefined } | undefined };

export type CreateRouteMutationVariables = Exact<{
  code: Scalars['String']['input'];
  type?: InputMaybe<TradeDirection>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateRouteMutation = { __typename?: 'Mutation', createRoute?: { __typename?: 'CreateRoutePayload', clientMutationId?: string | undefined } | undefined };

export type CreateRouteVesselMutationVariables = Exact<{
  routeId: Scalars['Int']['input'];
  vesselId: Scalars['Int']['input'];
}>;


export type CreateRouteVesselMutation = { __typename?: 'Mutation', createRouteVessel?: { __typename?: 'CreateRouteVesselPayload', clientMutationId?: string | undefined } | undefined };

export type CreateShippingCompanyMutationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateShippingCompanyMutationMutation = { __typename?: 'Mutation', createShipCompany?: { __typename?: 'CreateShipCompanyPayload', clientMutationId?: string | undefined } | undefined };

export type CreateTollFeeMutationVariables = Exact<{
  companyId: Scalars['BigInt']['input'];
  stateId?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  validFrom?: InputMaybe<Scalars['Datetime']['input']>;
  validTo?: InputMaybe<Scalars['Datetime']['input']>;
}>;


export type CreateTollFeeMutation = { __typename?: 'Mutation', createTollFee?: { __typename?: 'CreateTollFeePayload', clientMutationId?: string | undefined } | undefined };

export type CreateTransportPriceMutationVariables = Exact<{
  truckCompanyId?: InputMaybe<Scalars['Int']['input']>;
  suburbId?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  containerType?: InputMaybe<ContainerSizeEnum>;
  unloadMethod?: InputMaybe<UnloadMethod>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CreateTransportPriceMutation = { __typename?: 'Mutation', createTransportPrice?: { __typename?: 'CreateTransportPricePayload', clientMutationId?: string | undefined } | undefined };

export type CreateTruckCompanyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  abn?: InputMaybe<Scalars['String']['input']>;
  extraCharge?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CreateTruckCompanyMutation = { __typename?: 'Mutation', createTruckCompany?: { __typename?: 'CreateTruckCompanyPayload', clientMutationId?: string | undefined } | undefined };

export type CreateVesselMutationVariables = Exact<{
  shipCompanyId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  imo?: InputMaybe<Scalars['Int']['input']>;
  mmsi?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateVesselMutation = { __typename?: 'Mutation', createVessel?: { __typename?: 'CreateVesselPayload', clientMutationId?: string | undefined } | undefined };

export type CreateWharfPriceMutationVariables = Exact<{
  truckCompanyId?: InputMaybe<Scalars['Int']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  tradeDirection?: InputMaybe<TradeDirection>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  wharfName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateWharfPriceMutation = { __typename?: 'Mutation', createWharfPrice?: { __typename?: 'CreateWharfPricePayload', clientMutationId?: string | undefined } | undefined };

export type DeleteAgentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAgentMutation = { __typename?: 'Mutation', deleteAgentById?: { __typename?: 'DeleteAgentPayload', clientMutationId?: string | undefined } | undefined };

export type DeleteBookingByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBookingByIdMutation = { __typename?: 'Mutation', deleteBookingById?: { __typename?: 'DeleteBookingPayload', clientMutationId?: string | undefined } | undefined };

export type DeletePortByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DeletePortByIdMutation = { __typename?: 'Mutation', deletePortById?: { __typename?: 'DeletePortPayload', clientMutationId?: string | undefined } | undefined };

export type DeleteRouteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteRouteMutation = { __typename?: 'Mutation', deleteRouteById?: { __typename?: 'DeleteRoutePayload', clientMutationId?: string | undefined } | undefined };

export type DeleteRouteVesselByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteRouteVesselByIdMutation = { __typename?: 'Mutation', deleteRouteVesselById?: { __typename?: 'DeleteRouteVesselPayload', clientMutationId?: string | undefined } | undefined };

export type DeleteShippingCompanyMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteShippingCompanyMutationMutation = { __typename?: 'Mutation', deleteShipCompanyById?: { __typename?: 'DeleteShipCompanyPayload', clientMutationId?: string | undefined } | undefined };

export type DeleteTransportPriceByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTransportPriceByIdMutation = { __typename?: 'Mutation', deleteTransportPriceById?: { __typename?: 'DeleteTransportPricePayload', clientMutationId?: string | undefined } | undefined };

export type DeleteTruckCompanyByIdMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type DeleteTruckCompanyByIdMutation = { __typename?: 'Mutation', deleteTruckCompanyById?: { __typename?: 'DeleteTruckCompanyPayload', clientMutationId?: string | undefined } | undefined };

export type DeleteVesselByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteVesselByIdMutation = { __typename?: 'Mutation', deleteVesselById?: { __typename?: 'DeleteVesselPayload', clientMutationId?: string | undefined } | undefined };

export type UpdateAgentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  abn?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateAgentMutation = { __typename?: 'Mutation', updateAgentById?: { __typename?: 'UpdateAgentPayload', clientMutationId?: string | undefined } | undefined };

export type UpdateBookingByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBookingByIdMutation = { __typename?: 'Mutation', updateBookingById?: { __typename?: 'UpdateBookingPayload', clientMutationId?: string | undefined, booking?: { __typename?: 'Booking', id: number, remark?: string | undefined } | undefined } | undefined };

export type UpdateBookingPricesMutationVariables = Exact<{
  _bookingId: Scalars['Int']['input'];
  _prices: Scalars['JSON']['input'];
}>;


export type UpdateBookingPricesMutation = { __typename?: 'Mutation', fUpdateTierPrices?: { __typename?: 'FUpdateTierPricesPayload', clientMutationId?: string | undefined } | undefined };

export type UpdatePortByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  countryId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdatePortByIdMutation = { __typename?: 'Mutation', updatePortById?: { __typename?: 'UpdatePortPayload', clientMutationId?: string | undefined } | undefined };

export type UpdateRouteByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TradeDirection>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRouteByIdMutation = { __typename?: 'Mutation', updateRouteById?: { __typename?: 'UpdateRoutePayload', clientMutationId?: string | undefined, route?: { __typename?: 'Route', id: number, code: string, type?: TradeDirection | undefined, description?: string | undefined } | undefined } | undefined };

export type UpdateRoutePortsMutationVariables = Exact<{
  _ports?: InputMaybe<Scalars['JSON']['input']>;
  _routeId: Scalars['Int']['input'];
}>;


export type UpdateRoutePortsMutation = { __typename?: 'Mutation', fUpdateRoutePorts?: { __typename?: 'FUpdateRoutePortsPayload', clientMutationId?: string | undefined } | undefined };

export type UpdateShippingCompanyByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateShippingCompanyByIdMutation = { __typename?: 'Mutation', updateShipCompanyById?: { __typename?: 'UpdateShipCompanyPayload', clientMutationId?: string | undefined } | undefined };

export type UpdateTransportPriceByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  truckCompanyId?: InputMaybe<Scalars['Int']['input']>;
  suburbId?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  containerType?: InputMaybe<ContainerSizeEnum>;
  unloadMethod?: InputMaybe<UnloadMethod>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateTransportPriceByIdMutation = { __typename?: 'Mutation', updateTransportPriceById?: { __typename?: 'UpdateTransportPricePayload', clientMutationId?: string | undefined } | undefined };

export type UpdateTruckCompanyByIdMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  abn?: InputMaybe<Scalars['String']['input']>;
  extraCharge?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateTruckCompanyByIdMutation = { __typename?: 'Mutation', updateTruckCompanyById?: { __typename?: 'UpdateTruckCompanyPayload', clientMutationId?: string | undefined } | undefined };

export type UpdateVesselByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  imo?: InputMaybe<Scalars['Int']['input']>;
  mmsi?: InputMaybe<Scalars['Int']['input']>;
  shipCompanyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateVesselByIdMutation = { __typename?: 'Mutation', updateVesselById?: { __typename?: 'UpdateVesselPayload', clientMutationId?: string | undefined } | undefined };

export type AgentByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AgentByIdQuery = { __typename?: 'Query', agentById?: { __typename?: 'Agent', abn?: string | undefined, address?: string | undefined, email?: Array<string | undefined> | undefined, name: string, phone?: string | undefined, countryByCountryId?: { __typename?: 'Country', name: string, isoCode2: string, isoCode3: string } | undefined, bookingsByAgentId: { __typename?: 'BookingsConnection', nodes: Array<{ __typename?: 'Booking', id: number, etd?: any | undefined, currency: string, remark?: string | undefined, routeByRouteId?: { __typename?: 'Route', id: number, code: string, routeVesselsByRouteId: { __typename?: 'RouteVesselsConnection', nodes: Array<{ __typename?: 'RouteVessel', vesselByVesselId?: { __typename?: 'Vessel', id: number, name: string, shipCompanyByShipCompanyId?: { __typename?: 'ShipCompany', id: number, name: string } | undefined } | undefined } | undefined> } } | undefined, portByPod?: { __typename?: 'Port', id: number, name: string } | undefined, portByPol?: { __typename?: 'Port', id: number, name: string } | undefined, bookingPricesByBookingId: { __typename?: 'BookingPricesConnection', nodes: Array<{ __typename?: 'BookingPrice', containerSize?: ContainerSizeEnum | undefined, cost?: any | undefined, id: number } | undefined> } } | undefined> } } | undefined };

export type AllAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAgentsQuery = { __typename?: 'Query', allAgents?: { __typename?: 'AgentsConnection', nodes: Array<{ __typename?: 'Agent', id: number, name: string, address?: string | undefined, phone?: string | undefined, abn?: string | undefined, email?: Array<string | undefined> | undefined, countryByCountryId?: { __typename?: 'Country', id: number, name: string } | undefined } | undefined> } | undefined };

export type AllBookingPricesQueryVariables = Exact<{
  minEtd: Scalars['Date']['input'];
}>;


export type AllBookingPricesQuery = { __typename?: 'Query', allBookingPrices?: { __typename?: 'BookingPricesConnection', nodes: Array<{ __typename?: 'BookingPrice', containerSize?: ContainerSizeEnum | undefined, cost?: any | undefined, id: number, bookingByBookingId?: { __typename?: 'Booking', etd?: any | undefined, currency: string, remark?: string | undefined, agentByAgentId?: { __typename?: 'Agent', id: number, name: string } | undefined, routeByRouteId?: { __typename?: 'Route', id: number, code: string, routeVesselsByRouteId: { __typename?: 'RouteVesselsConnection', nodes: Array<{ __typename?: 'RouteVessel', vesselByVesselId?: { __typename?: 'Vessel', id: number, name: string, shipCompanyByShipCompanyId?: { __typename?: 'ShipCompany', id: number, name: string } | undefined } | undefined } | undefined> } } | undefined, portByPol?: { __typename?: 'Port', id: number, name: string } | undefined, portByDischargePort?: { __typename?: 'Port', id: number, name: string } | undefined, portByPod?: { __typename?: 'Port', id: number, name: string } | undefined } | undefined } | undefined> } | undefined };

export type AllBookingsQueryVariables = Exact<{
  agentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllBookingsQuery = { __typename?: 'Query', allBookings?: { __typename?: 'BookingsConnection', nodes: Array<{ __typename?: 'Booking', id: number, etd?: any | undefined, remark?: string | undefined, currency: string, routeId?: number | undefined, agentByAgentId?: { __typename?: 'Agent', id: number, name: string } | undefined, routeByRouteId?: { __typename?: 'Route', id: number, code: string, routeVesselsByRouteId: { __typename?: 'RouteVesselsConnection', nodes: Array<{ __typename?: 'RouteVessel', vesselByVesselId?: { __typename?: 'Vessel', id: number, name: string, shipCompanyByShipCompanyId?: { __typename?: 'ShipCompany', id: number, name: string } | undefined } | undefined } | undefined> } } | undefined, portByPod?: { __typename?: 'Port', id: number, name: string } | undefined, portByPol?: { __typename?: 'Port', id: number, name: string } | undefined, portByDischargePort?: { __typename?: 'Port', id: number, name: string } | undefined, bookingPricesByBookingId: { __typename?: 'BookingPricesConnection', nodes: Array<{ __typename?: 'BookingPrice', id: number, containerSize?: ContainerSizeEnum | undefined, cost?: any | undefined, bookingId?: number | undefined } | undefined> } } | undefined> } | undefined };

export type AllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesQuery = { __typename?: 'Query', allCountries?: { __typename?: 'CountriesConnection', totalCount: number, nodes: Array<{ __typename?: 'Country', name: string, isoCode3: string, isoCode2: string, id: number, currencyCode?: string | undefined, capital?: string | undefined, numericCode?: string | undefined, phoneCode?: string | undefined, region?: string | undefined, subregion?: string | undefined } | undefined> } | undefined };

export type AllParkPricesQueryVariables = Exact<{
  minValidTo: Scalars['Date']['input'];
}>;


export type AllParkPricesQuery = { __typename?: 'Query', allParkPrices?: { __typename?: 'ParkPricesConnection', nodes: Array<{ __typename?: 'ParkPrice', id: number, price?: any | undefined, parkName?: string | undefined, validTo?: any | undefined, truckCompanyByCompanyId?: { __typename?: 'TruckCompany', id: any, name: string } | undefined, stateByStateId?: { __typename?: 'State', code: string, name: string } | undefined } | undefined> } | undefined };

export type AllPortsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPortsQuery = { __typename?: 'Query', allPorts?: { __typename?: 'PortsConnection', nodes: Array<{ __typename?: 'Port', id: number, name: string, countryId?: number | undefined } | undefined> } | undefined };

export type AllRouteVesselsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRouteVesselsQuery = { __typename?: 'Query', allRouteVessels?: { __typename?: 'RouteVesselsConnection', nodes: Array<{ __typename?: 'RouteVessel', id: number, routeByRouteId?: { __typename?: 'Route', code: string, id: number, routePortsByRouteId: { __typename?: 'RoutePortsConnection', nodes: Array<{ __typename?: 'RoutePort', portOrder?: number | undefined, portByPortId?: { __typename?: 'Port', id: number, name: string } | undefined } | undefined> } } | undefined, vesselByVesselId?: { __typename?: 'Vessel', id: number, name: string, shipCompanyByShipCompanyId?: { __typename?: 'ShipCompany', name: string, id: number } | undefined } | undefined } | undefined> } | undefined };

export type AllRoutesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRoutesQuery = { __typename?: 'Query', allRoutes?: { __typename?: 'RoutesConnection', nodes: Array<{ __typename?: 'Route', id: number, code: string, type?: TradeDirection | undefined, description?: string | undefined, routePortsByRouteId: { __typename?: 'RoutePortsConnection', totalCount: number, nodes: Array<{ __typename?: 'RoutePort', date?: any | undefined, dow?: Dow | undefined, dateType?: DateType | undefined, portOrder?: number | undefined, portByPortId?: { __typename?: 'Port', id: number, name: string, countryId?: number | undefined } | undefined } | undefined> } } | undefined> } | undefined };

export type AllShipCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllShipCompaniesQuery = { __typename?: 'Query', allShipCompanies?: { __typename?: 'ShipCompaniesConnection', nodes: Array<{ __typename?: 'ShipCompany', id: number, name: string } | undefined> } | undefined };

export type AllStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStatesQuery = { __typename?: 'Query', allStates?: { __typename?: 'StatesConnection', nodes: Array<{ __typename?: 'State', code: string, name: string } | undefined> } | undefined };

export type AllSuburbsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSuburbsQuery = { __typename?: 'Query', allSuburbs?: { __typename?: 'SuburbsConnection', nodes: Array<{ __typename?: 'Suburb', id: any, name: string, postcode: string, stateCode: string } | undefined> } | undefined };

export type AllTransportPricesQueryVariables = Exact<{
  minValidTo: Scalars['Date']['input'];
}>;


export type AllTransportPricesQuery = { __typename?: 'Query', allTransportPrices?: { __typename?: 'TransportPricesConnection', nodes: Array<{ __typename?: 'TransportPrice', id: number, price?: any | undefined, containerType?: ContainerSizeEnum | undefined, unloadMethod?: UnloadMethod | undefined, validTo?: any | undefined, truckCompanyByTruckCompanyId?: { __typename?: 'TruckCompany', id: any, name: string } | undefined, suburbBySuburbId?: { __typename?: 'Suburb', id: any, name: string, postcode: string, stateCode: string } | undefined } | undefined> } | undefined };

export type AllTruckCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTruckCompaniesQuery = { __typename?: 'Query', allTruckCompanies?: { __typename?: 'TruckCompaniesConnection', nodes: Array<{ __typename?: 'TruckCompany', id: any, name: string, email?: Array<string | undefined> | undefined, phone?: string | undefined, address?: string | undefined, note?: string | undefined, abn?: string | undefined } | undefined> } | undefined };

export type AllVesselsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllVesselsQuery = { __typename?: 'Query', allVessels?: { __typename?: 'VesselsConnection', nodes: Array<{ __typename?: 'Vessel', name: string, mmsi?: number | undefined, imo?: number | undefined, id: number, routeVesselsByVesselId: { __typename?: 'RouteVesselsConnection', nodes: Array<{ __typename?: 'RouteVessel', routeByRouteId?: { __typename?: 'Route', id: number, code: string } | undefined } | undefined> }, shipCompanyByShipCompanyId?: { __typename?: 'ShipCompany', id: number, name: string } | undefined } | undefined> } | undefined };

export type AllWharfPricesQueryVariables = Exact<{
  maxValidFrom: Scalars['Date']['input'];
}>;


export type AllWharfPricesQuery = { __typename?: 'Query', allWharfPrices?: { __typename?: 'WharfPricesConnection', nodes: Array<{ __typename?: 'WharfPrice', id: number, price?: any | undefined, tradeDirection?: TradeDirection | undefined, validFrom?: any | undefined, truckCompanyByTruckCompanyId?: { __typename?: 'TruckCompany', id: any, name: string } | undefined, stateByStateId?: { __typename?: 'State', code: string, name: string } | undefined } | undefined> } | undefined };

export type FuelLeviesByTruckCompanyIdQueryVariables = Exact<{
  truckCompanyId: Scalars['BigInt']['input'];
}>;


export type FuelLeviesByTruckCompanyIdQuery = { __typename?: 'Query', allFuelLevies?: { __typename?: 'FuelLeviesConnection', nodes: Array<{ __typename?: 'FuelLevy', id: any, levy?: any | undefined, validFrom?: any | undefined, validTo?: any | undefined } | undefined> } | undefined };

export type PortByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PortByIdQuery = { __typename?: 'Query', portById?: { __typename?: 'Port', id: number, name: string, countryId?: number | undefined, routePortsByPortId: { __typename?: 'RoutePortsConnection', nodes: Array<{ __typename?: 'RoutePort', id: number, portOrder?: number | undefined, date?: any | undefined, dow?: Dow | undefined, dateType?: DateType | undefined, routeByRouteId?: { __typename?: 'Route', id: number, code: string, description?: string | undefined, routeVesselsByRouteId: { __typename?: 'RouteVesselsConnection', nodes: Array<{ __typename?: 'RouteVessel', id: number, vesselByVesselId?: { __typename?: 'Vessel', name: string, id: number, shipCompanyByShipCompanyId?: { __typename?: 'ShipCompany', id: number, name: string } | undefined } | undefined } | undefined> } } | undefined } | undefined> } } | undefined };

export type RouteByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RouteByIdQuery = { __typename?: 'Query', routeById?: { __typename?: 'Route', id: number, code: string, type?: TradeDirection | undefined, description?: string | undefined, routeVesselsByRouteId: { __typename?: 'RouteVesselsConnection', nodes: Array<{ __typename?: 'RouteVessel', id: number, vesselByVesselId?: { __typename?: 'Vessel', id: number, name: string, imo?: number | undefined, shipCompanyByShipCompanyId?: { __typename?: 'ShipCompany', id: number, name: string } | undefined } | undefined } | undefined> }, routePortsByRouteId: { __typename?: 'RoutePortsConnection', totalCount: number, nodes: Array<{ __typename?: 'RoutePort', date?: any | undefined, dow?: Dow | undefined, dateType?: DateType | undefined, portOrder?: number | undefined, portByPortId?: { __typename?: 'Port', id: number, name: string, countryId?: number | undefined } | undefined } | undefined> } } | undefined };

export type ShipCompanyByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ShipCompanyByIdQuery = { __typename?: 'Query', shipCompanyById?: { __typename?: 'ShipCompany', id: number, name: string, vesselsByShipCompanyId: { __typename?: 'VesselsConnection', nodes: Array<{ __typename?: 'Vessel', id: number, imo?: number | undefined, name: string, routeVesselsByVesselId: { __typename?: 'RouteVesselsConnection', nodes: Array<{ __typename?: 'RouteVessel', routeByRouteId?: { __typename?: 'Route', code: string, id: number, routePortsByRouteId: { __typename?: 'RoutePortsConnection', nodes: Array<{ __typename?: 'RoutePort', portByPortId?: { __typename?: 'Port', id: number, name: string } | undefined } | undefined> } } | undefined } | undefined> } } | undefined> } } | undefined };

export type TruckCompanyByIdQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;


export type TruckCompanyByIdQuery = { __typename?: 'Query', truckCompanyById?: { __typename?: 'TruckCompany', id: any, name: string, email?: Array<string | undefined> | undefined, phone?: string | undefined, address?: string | undefined, note?: string | undefined, abn?: string | undefined, extraCharge?: any | undefined, transportPricesByTruckCompanyId: { __typename?: 'TransportPricesConnection', nodes: Array<{ __typename?: 'TransportPrice', id: number, price?: any | undefined, containerType?: ContainerSizeEnum | undefined, unloadMethod?: UnloadMethod | undefined, validTo?: any | undefined, suburbBySuburbId?: { __typename?: 'Suburb', id: any, name: string, postcode: string, stateCode: string } | undefined } | undefined> }, wharfPricesByTruckCompanyId: { __typename?: 'WharfPricesConnection', nodes: Array<{ __typename?: 'WharfPrice', id: number, price?: any | undefined, tradeDirection?: TradeDirection | undefined, validFrom?: any | undefined, wharfName?: string | undefined, stateByStateId?: { __typename?: 'State', code: string, name: string } | undefined, truckCompanyByTruckCompanyId?: { __typename?: 'TruckCompany', id: any, name: string } | undefined } | undefined> }, parkPricesByCompanyId: { __typename?: 'ParkPricesConnection', nodes: Array<{ __typename?: 'ParkPrice', id: number, price?: any | undefined, parkName?: string | undefined, validTo?: any | undefined, stateByStateId?: { __typename?: 'State', code: string, name: string } | undefined } | undefined> }, tollFeesByCompanyId: { __typename?: 'TollFeesConnection', nodes: Array<{ __typename?: 'TollFee', id: any, fee?: any | undefined, stateId?: string | undefined, validFrom?: any | undefined, validTo?: any | undefined, stateByStateId?: { __typename?: 'State', code: string, name: string } | undefined } | undefined> } } | undefined };

export type VesselByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type VesselByIdQuery = { __typename?: 'Query', vesselById?: { __typename?: 'Vessel', id: number, name: string, imo?: number | undefined, mmsi?: number | undefined, shipCompanyId?: number | undefined, shipCompanyByShipCompanyId?: { __typename?: 'ShipCompany', id: number, name: string } | undefined } | undefined };

export const AgentFragmentFragmentDoc = gql`
    fragment AgentFragment on Agent {
  id
  name
}
    `;
export const BookingPriceFragmentFragmentDoc = gql`
    fragment BookingPriceFragment on BookingPrice {
  id
  containerSize
  cost
  bookingId
}
    `;
export const RouteFragmentFragmentDoc = gql`
    fragment RouteFragment on Route {
  id
  code
  type
  description
  routePortsByRouteId(orderBy: PORT_ORDER_ASC) {
    nodes {
      portByPortId {
        id
        name
        countryId
      }
      date
      dow
      dateType
      portOrder
    }
    totalCount
  }
}
    `;
export const VesselFragmentFragmentDoc = gql`
    fragment VesselFragment on Vessel {
  id
  name
}
    `;
export const CreateAgentDocument = gql`
    mutation CreateAgent($name: String!, $address: String, $phone: String, $abn: String, $email: [String], $countryId: Int) {
  createAgent(
    input: {agent: {name: $name, address: $address, phone: $phone, abn: $abn, email: $email, countryId: $countryId}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateAgentMutationFn = Apollo.MutationFunction<CreateAgentMutation, CreateAgentMutationVariables>;
export function useCreateAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentMutation, CreateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentMutation, CreateAgentMutationVariables>(CreateAgentDocument, options);
      }
export type CreateAgentMutationHookResult = ReturnType<typeof useCreateAgentMutation>;
export type CreateAgentMutationResult = Apollo.MutationResult<CreateAgentMutation>;
export type CreateAgentMutationOptions = Apollo.BaseMutationOptions<CreateAgentMutation, CreateAgentMutationVariables>;
export const CreateBookingDocument = gql`
    mutation CreateBooking($agentId: Int!, $currency: String, $etd: Date!, $remark: String, $routeId: Int!, $pod: Int, $pol: Int, $dischargePort: Int) {
  createBooking(
    input: {booking: {agentId: $agentId, currency: $currency, etd: $etd, remark: $remark, routeId: $routeId, pod: $pod, pol: $pol, dischargePort: $dischargePort}}
  ) {
    booking {
      id
      etd
      currency
      remark
      routeId
      routeByRouteId {
        id
        code
        routeVesselsByRouteId {
          nodes {
            vesselByVesselId {
              id
              name
              shipCompanyByShipCompanyId {
                id
                name
              }
            }
          }
        }
      }
      agentByAgentId {
        id
        name
      }
      portByPod {
        id
        name
      }
      portByPol {
        id
        name
      }
      portByDischargePort {
        id
        name
      }
      bookingPricesByBookingId {
        nodes {
          containerSize
          cost
          id
        }
      }
    }
    clientMutationId
  }
}
    `;
export type CreateBookingMutationFn = Apollo.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;
export function useCreateBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, options);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = Apollo.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = Apollo.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const CreateFuelLevyDocument = gql`
    mutation CreateFuelLevy($truckCompanyId: BigInt!, $levy: BigFloat, $validFrom: Datetime, $validTo: Datetime) {
  createFuelLevy(
    input: {fuelLevy: {truckCompanyId: $truckCompanyId, levy: $levy, validFrom: $validFrom, validTo: $validTo}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateFuelLevyMutationFn = Apollo.MutationFunction<CreateFuelLevyMutation, CreateFuelLevyMutationVariables>;
export function useCreateFuelLevyMutation(baseOptions?: Apollo.MutationHookOptions<CreateFuelLevyMutation, CreateFuelLevyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFuelLevyMutation, CreateFuelLevyMutationVariables>(CreateFuelLevyDocument, options);
      }
export type CreateFuelLevyMutationHookResult = ReturnType<typeof useCreateFuelLevyMutation>;
export type CreateFuelLevyMutationResult = Apollo.MutationResult<CreateFuelLevyMutation>;
export type CreateFuelLevyMutationOptions = Apollo.BaseMutationOptions<CreateFuelLevyMutation, CreateFuelLevyMutationVariables>;
export const CreateParkPriceDocument = gql`
    mutation CreateParkPrice($companyId: BigInt!, $stateId: String, $parkName: String, $price: BigFloat, $validTo: Date) {
  createParkPrice(
    input: {parkPrice: {companyId: $companyId, stateId: $stateId, parkName: $parkName, price: $price, validTo: $validTo}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateParkPriceMutationFn = Apollo.MutationFunction<CreateParkPriceMutation, CreateParkPriceMutationVariables>;
export function useCreateParkPriceMutation(baseOptions?: Apollo.MutationHookOptions<CreateParkPriceMutation, CreateParkPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateParkPriceMutation, CreateParkPriceMutationVariables>(CreateParkPriceDocument, options);
      }
export type CreateParkPriceMutationHookResult = ReturnType<typeof useCreateParkPriceMutation>;
export type CreateParkPriceMutationResult = Apollo.MutationResult<CreateParkPriceMutation>;
export type CreateParkPriceMutationOptions = Apollo.BaseMutationOptions<CreateParkPriceMutation, CreateParkPriceMutationVariables>;
export const CreatePortMutationDocument = gql`
    mutation CreatePortMutation($name: String!, $countryId: Int) {
  createPort(input: {port: {name: $name, countryId: $countryId}}) {
    clientMutationId
  }
}
    `;
export type CreatePortMutationMutationFn = Apollo.MutationFunction<CreatePortMutationMutation, CreatePortMutationMutationVariables>;
export function useCreatePortMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortMutationMutation, CreatePortMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortMutationMutation, CreatePortMutationMutationVariables>(CreatePortMutationDocument, options);
      }
export type CreatePortMutationMutationHookResult = ReturnType<typeof useCreatePortMutationMutation>;
export type CreatePortMutationMutationResult = Apollo.MutationResult<CreatePortMutationMutation>;
export type CreatePortMutationMutationOptions = Apollo.BaseMutationOptions<CreatePortMutationMutation, CreatePortMutationMutationVariables>;
export const CreateRouteDocument = gql`
    mutation CreateRoute($code: String!, $type: TradeDirection, $description: String) {
  createRoute(
    input: {route: {code: $code, type: $type, description: $description}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateRouteMutationFn = Apollo.MutationFunction<CreateRouteMutation, CreateRouteMutationVariables>;
export function useCreateRouteMutation(baseOptions?: Apollo.MutationHookOptions<CreateRouteMutation, CreateRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRouteMutation, CreateRouteMutationVariables>(CreateRouteDocument, options);
      }
export type CreateRouteMutationHookResult = ReturnType<typeof useCreateRouteMutation>;
export type CreateRouteMutationResult = Apollo.MutationResult<CreateRouteMutation>;
export type CreateRouteMutationOptions = Apollo.BaseMutationOptions<CreateRouteMutation, CreateRouteMutationVariables>;
export const CreateRouteVesselDocument = gql`
    mutation CreateRouteVessel($routeId: Int!, $vesselId: Int!) {
  createRouteVessel(
    input: {routeVessel: {vesselId: $vesselId, routeId: $routeId}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateRouteVesselMutationFn = Apollo.MutationFunction<CreateRouteVesselMutation, CreateRouteVesselMutationVariables>;
export function useCreateRouteVesselMutation(baseOptions?: Apollo.MutationHookOptions<CreateRouteVesselMutation, CreateRouteVesselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRouteVesselMutation, CreateRouteVesselMutationVariables>(CreateRouteVesselDocument, options);
      }
export type CreateRouteVesselMutationHookResult = ReturnType<typeof useCreateRouteVesselMutation>;
export type CreateRouteVesselMutationResult = Apollo.MutationResult<CreateRouteVesselMutation>;
export type CreateRouteVesselMutationOptions = Apollo.BaseMutationOptions<CreateRouteVesselMutation, CreateRouteVesselMutationVariables>;
export const CreateShippingCompanyMutationDocument = gql`
    mutation CreateShippingCompanyMutation($name: String!) {
  createShipCompany(input: {shipCompany: {name: $name}}) {
    clientMutationId
  }
}
    `;
export type CreateShippingCompanyMutationMutationFn = Apollo.MutationFunction<CreateShippingCompanyMutationMutation, CreateShippingCompanyMutationMutationVariables>;
export function useCreateShippingCompanyMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateShippingCompanyMutationMutation, CreateShippingCompanyMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShippingCompanyMutationMutation, CreateShippingCompanyMutationMutationVariables>(CreateShippingCompanyMutationDocument, options);
      }
export type CreateShippingCompanyMutationMutationHookResult = ReturnType<typeof useCreateShippingCompanyMutationMutation>;
export type CreateShippingCompanyMutationMutationResult = Apollo.MutationResult<CreateShippingCompanyMutationMutation>;
export type CreateShippingCompanyMutationMutationOptions = Apollo.BaseMutationOptions<CreateShippingCompanyMutationMutation, CreateShippingCompanyMutationMutationVariables>;
export const CreateTollFeeDocument = gql`
    mutation CreateTollFee($companyId: BigInt!, $stateId: String, $fee: BigFloat, $validFrom: Datetime, $validTo: Datetime) {
  createTollFee(
    input: {tollFee: {companyId: $companyId, stateId: $stateId, fee: $fee, validFrom: $validFrom, validTo: $validTo}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateTollFeeMutationFn = Apollo.MutationFunction<CreateTollFeeMutation, CreateTollFeeMutationVariables>;
export function useCreateTollFeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateTollFeeMutation, CreateTollFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTollFeeMutation, CreateTollFeeMutationVariables>(CreateTollFeeDocument, options);
      }
export type CreateTollFeeMutationHookResult = ReturnType<typeof useCreateTollFeeMutation>;
export type CreateTollFeeMutationResult = Apollo.MutationResult<CreateTollFeeMutation>;
export type CreateTollFeeMutationOptions = Apollo.BaseMutationOptions<CreateTollFeeMutation, CreateTollFeeMutationVariables>;
export const CreateTransportPriceDocument = gql`
    mutation CreateTransportPrice($truckCompanyId: Int, $suburbId: Int, $price: BigFloat, $containerType: ContainerSizeEnum, $unloadMethod: UnloadMethod, $validTo: Date) {
  createTransportPrice(
    input: {transportPrice: {truckCompanyId: $truckCompanyId, suburbId: $suburbId, price: $price, containerType: $containerType, unloadMethod: $unloadMethod, validTo: $validTo}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateTransportPriceMutationFn = Apollo.MutationFunction<CreateTransportPriceMutation, CreateTransportPriceMutationVariables>;
export function useCreateTransportPriceMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransportPriceMutation, CreateTransportPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransportPriceMutation, CreateTransportPriceMutationVariables>(CreateTransportPriceDocument, options);
      }
export type CreateTransportPriceMutationHookResult = ReturnType<typeof useCreateTransportPriceMutation>;
export type CreateTransportPriceMutationResult = Apollo.MutationResult<CreateTransportPriceMutation>;
export type CreateTransportPriceMutationOptions = Apollo.BaseMutationOptions<CreateTransportPriceMutation, CreateTransportPriceMutationVariables>;
export const CreateTruckCompanyDocument = gql`
    mutation CreateTruckCompany($name: String!, $email: [String], $phone: String, $address: String, $note: String, $abn: String, $extraCharge: JSON) {
  createTruckCompany(
    input: {truckCompany: {name: $name, email: $email, phone: $phone, address: $address, note: $note, abn: $abn, extraCharge: $extraCharge}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateTruckCompanyMutationFn = Apollo.MutationFunction<CreateTruckCompanyMutation, CreateTruckCompanyMutationVariables>;
export function useCreateTruckCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateTruckCompanyMutation, CreateTruckCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTruckCompanyMutation, CreateTruckCompanyMutationVariables>(CreateTruckCompanyDocument, options);
      }
export type CreateTruckCompanyMutationHookResult = ReturnType<typeof useCreateTruckCompanyMutation>;
export type CreateTruckCompanyMutationResult = Apollo.MutationResult<CreateTruckCompanyMutation>;
export type CreateTruckCompanyMutationOptions = Apollo.BaseMutationOptions<CreateTruckCompanyMutation, CreateTruckCompanyMutationVariables>;
export const CreateVesselDocument = gql`
    mutation CreateVessel($shipCompanyId: Int!, $name: String!, $imo: Int, $mmsi: Int) {
  createVessel(
    input: {vessel: {name: $name, shipCompanyId: $shipCompanyId, imo: $imo, mmsi: $mmsi}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateVesselMutationFn = Apollo.MutationFunction<CreateVesselMutation, CreateVesselMutationVariables>;
export function useCreateVesselMutation(baseOptions?: Apollo.MutationHookOptions<CreateVesselMutation, CreateVesselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVesselMutation, CreateVesselMutationVariables>(CreateVesselDocument, options);
      }
export type CreateVesselMutationHookResult = ReturnType<typeof useCreateVesselMutation>;
export type CreateVesselMutationResult = Apollo.MutationResult<CreateVesselMutation>;
export type CreateVesselMutationOptions = Apollo.BaseMutationOptions<CreateVesselMutation, CreateVesselMutationVariables>;
export const CreateWharfPriceDocument = gql`
    mutation CreateWharfPrice($truckCompanyId: Int, $stateId: String, $price: BigFloat, $tradeDirection: TradeDirection, $validFrom: Date, $wharfName: String) {
  createWharfPrice(
    input: {wharfPrice: {truckCompanyId: $truckCompanyId, stateId: $stateId, price: $price, tradeDirection: $tradeDirection, validFrom: $validFrom, wharfName: $wharfName}}
  ) {
    clientMutationId
  }
}
    `;
export type CreateWharfPriceMutationFn = Apollo.MutationFunction<CreateWharfPriceMutation, CreateWharfPriceMutationVariables>;
export function useCreateWharfPriceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWharfPriceMutation, CreateWharfPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWharfPriceMutation, CreateWharfPriceMutationVariables>(CreateWharfPriceDocument, options);
      }
export type CreateWharfPriceMutationHookResult = ReturnType<typeof useCreateWharfPriceMutation>;
export type CreateWharfPriceMutationResult = Apollo.MutationResult<CreateWharfPriceMutation>;
export type CreateWharfPriceMutationOptions = Apollo.BaseMutationOptions<CreateWharfPriceMutation, CreateWharfPriceMutationVariables>;
export const DeleteAgentDocument = gql`
    mutation DeleteAgent($id: Int!) {
  deleteAgentById(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteAgentMutationFn = Apollo.MutationFunction<DeleteAgentMutation, DeleteAgentMutationVariables>;
export function useDeleteAgentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgentMutation, DeleteAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgentMutation, DeleteAgentMutationVariables>(DeleteAgentDocument, options);
      }
export type DeleteAgentMutationHookResult = ReturnType<typeof useDeleteAgentMutation>;
export type DeleteAgentMutationResult = Apollo.MutationResult<DeleteAgentMutation>;
export type DeleteAgentMutationOptions = Apollo.BaseMutationOptions<DeleteAgentMutation, DeleteAgentMutationVariables>;
export const DeleteBookingByIdDocument = gql`
    mutation DeleteBookingById($id: Int!) {
  deleteBookingById(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteBookingByIdMutationFn = Apollo.MutationFunction<DeleteBookingByIdMutation, DeleteBookingByIdMutationVariables>;
export function useDeleteBookingByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingByIdMutation, DeleteBookingByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookingByIdMutation, DeleteBookingByIdMutationVariables>(DeleteBookingByIdDocument, options);
      }
export type DeleteBookingByIdMutationHookResult = ReturnType<typeof useDeleteBookingByIdMutation>;
export type DeleteBookingByIdMutationResult = Apollo.MutationResult<DeleteBookingByIdMutation>;
export type DeleteBookingByIdMutationOptions = Apollo.BaseMutationOptions<DeleteBookingByIdMutation, DeleteBookingByIdMutationVariables>;
export const DeletePortByIdDocument = gql`
    mutation DeletePortById($id: Int = 10) {
  deletePortById(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeletePortByIdMutationFn = Apollo.MutationFunction<DeletePortByIdMutation, DeletePortByIdMutationVariables>;
export function useDeletePortByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeletePortByIdMutation, DeletePortByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePortByIdMutation, DeletePortByIdMutationVariables>(DeletePortByIdDocument, options);
      }
export type DeletePortByIdMutationHookResult = ReturnType<typeof useDeletePortByIdMutation>;
export type DeletePortByIdMutationResult = Apollo.MutationResult<DeletePortByIdMutation>;
export type DeletePortByIdMutationOptions = Apollo.BaseMutationOptions<DeletePortByIdMutation, DeletePortByIdMutationVariables>;
export const DeleteRouteDocument = gql`
    mutation DeleteRoute($id: Int!) {
  deleteRouteById(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteRouteMutationFn = Apollo.MutationFunction<DeleteRouteMutation, DeleteRouteMutationVariables>;
export function useDeleteRouteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRouteMutation, DeleteRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRouteMutation, DeleteRouteMutationVariables>(DeleteRouteDocument, options);
      }
export type DeleteRouteMutationHookResult = ReturnType<typeof useDeleteRouteMutation>;
export type DeleteRouteMutationResult = Apollo.MutationResult<DeleteRouteMutation>;
export type DeleteRouteMutationOptions = Apollo.BaseMutationOptions<DeleteRouteMutation, DeleteRouteMutationVariables>;
export const DeleteRouteVesselByIdDocument = gql`
    mutation DeleteRouteVesselById($id: Int!) {
  deleteRouteVesselById(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteRouteVesselByIdMutationFn = Apollo.MutationFunction<DeleteRouteVesselByIdMutation, DeleteRouteVesselByIdMutationVariables>;
export function useDeleteRouteVesselByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRouteVesselByIdMutation, DeleteRouteVesselByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRouteVesselByIdMutation, DeleteRouteVesselByIdMutationVariables>(DeleteRouteVesselByIdDocument, options);
      }
export type DeleteRouteVesselByIdMutationHookResult = ReturnType<typeof useDeleteRouteVesselByIdMutation>;
export type DeleteRouteVesselByIdMutationResult = Apollo.MutationResult<DeleteRouteVesselByIdMutation>;
export type DeleteRouteVesselByIdMutationOptions = Apollo.BaseMutationOptions<DeleteRouteVesselByIdMutation, DeleteRouteVesselByIdMutationVariables>;
export const DeleteShippingCompanyMutationDocument = gql`
    mutation DeleteShippingCompanyMutation($id: Int!) {
  deleteShipCompanyById(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteShippingCompanyMutationMutationFn = Apollo.MutationFunction<DeleteShippingCompanyMutationMutation, DeleteShippingCompanyMutationMutationVariables>;
export function useDeleteShippingCompanyMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShippingCompanyMutationMutation, DeleteShippingCompanyMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShippingCompanyMutationMutation, DeleteShippingCompanyMutationMutationVariables>(DeleteShippingCompanyMutationDocument, options);
      }
export type DeleteShippingCompanyMutationMutationHookResult = ReturnType<typeof useDeleteShippingCompanyMutationMutation>;
export type DeleteShippingCompanyMutationMutationResult = Apollo.MutationResult<DeleteShippingCompanyMutationMutation>;
export type DeleteShippingCompanyMutationMutationOptions = Apollo.BaseMutationOptions<DeleteShippingCompanyMutationMutation, DeleteShippingCompanyMutationMutationVariables>;
export const DeleteTransportPriceByIdDocument = gql`
    mutation DeleteTransportPriceById($id: Int!) {
  deleteTransportPriceById(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteTransportPriceByIdMutationFn = Apollo.MutationFunction<DeleteTransportPriceByIdMutation, DeleteTransportPriceByIdMutationVariables>;
export function useDeleteTransportPriceByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransportPriceByIdMutation, DeleteTransportPriceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransportPriceByIdMutation, DeleteTransportPriceByIdMutationVariables>(DeleteTransportPriceByIdDocument, options);
      }
export type DeleteTransportPriceByIdMutationHookResult = ReturnType<typeof useDeleteTransportPriceByIdMutation>;
export type DeleteTransportPriceByIdMutationResult = Apollo.MutationResult<DeleteTransportPriceByIdMutation>;
export type DeleteTransportPriceByIdMutationOptions = Apollo.BaseMutationOptions<DeleteTransportPriceByIdMutation, DeleteTransportPriceByIdMutationVariables>;
export const DeleteTruckCompanyByIdDocument = gql`
    mutation DeleteTruckCompanyById($id: BigInt!) {
  deleteTruckCompanyById(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteTruckCompanyByIdMutationFn = Apollo.MutationFunction<DeleteTruckCompanyByIdMutation, DeleteTruckCompanyByIdMutationVariables>;
export function useDeleteTruckCompanyByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTruckCompanyByIdMutation, DeleteTruckCompanyByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTruckCompanyByIdMutation, DeleteTruckCompanyByIdMutationVariables>(DeleteTruckCompanyByIdDocument, options);
      }
export type DeleteTruckCompanyByIdMutationHookResult = ReturnType<typeof useDeleteTruckCompanyByIdMutation>;
export type DeleteTruckCompanyByIdMutationResult = Apollo.MutationResult<DeleteTruckCompanyByIdMutation>;
export type DeleteTruckCompanyByIdMutationOptions = Apollo.BaseMutationOptions<DeleteTruckCompanyByIdMutation, DeleteTruckCompanyByIdMutationVariables>;
export const DeleteVesselByIdDocument = gql`
    mutation DeleteVesselById($id: Int!) {
  deleteVesselById(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteVesselByIdMutationFn = Apollo.MutationFunction<DeleteVesselByIdMutation, DeleteVesselByIdMutationVariables>;
export function useDeleteVesselByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVesselByIdMutation, DeleteVesselByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVesselByIdMutation, DeleteVesselByIdMutationVariables>(DeleteVesselByIdDocument, options);
      }
export type DeleteVesselByIdMutationHookResult = ReturnType<typeof useDeleteVesselByIdMutation>;
export type DeleteVesselByIdMutationResult = Apollo.MutationResult<DeleteVesselByIdMutation>;
export type DeleteVesselByIdMutationOptions = Apollo.BaseMutationOptions<DeleteVesselByIdMutation, DeleteVesselByIdMutationVariables>;
export const UpdateAgentDocument = gql`
    mutation UpdateAgent($id: Int!, $name: String!, $address: String, $phone: String, $abn: String, $email: [String], $countryId: Int) {
  updateAgentById(
    input: {agentPatch: {name: $name, address: $address, phone: $phone, abn: $abn, email: $email, countryId: $countryId}, id: $id}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateAgentMutationFn = Apollo.MutationFunction<UpdateAgentMutation, UpdateAgentMutationVariables>;
export function useUpdateAgentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgentMutation, UpdateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgentMutation, UpdateAgentMutationVariables>(UpdateAgentDocument, options);
      }
export type UpdateAgentMutationHookResult = ReturnType<typeof useUpdateAgentMutation>;
export type UpdateAgentMutationResult = Apollo.MutationResult<UpdateAgentMutation>;
export type UpdateAgentMutationOptions = Apollo.BaseMutationOptions<UpdateAgentMutation, UpdateAgentMutationVariables>;
export const UpdateBookingByIdDocument = gql`
    mutation UpdateBookingById($id: Int!, $remark: String) {
  updateBookingById(input: {bookingPatch: {remark: $remark}, id: $id}) {
    clientMutationId
    booking {
      id
      remark
    }
  }
}
    `;
export type UpdateBookingByIdMutationFn = Apollo.MutationFunction<UpdateBookingByIdMutation, UpdateBookingByIdMutationVariables>;
export function useUpdateBookingByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingByIdMutation, UpdateBookingByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingByIdMutation, UpdateBookingByIdMutationVariables>(UpdateBookingByIdDocument, options);
      }
export type UpdateBookingByIdMutationHookResult = ReturnType<typeof useUpdateBookingByIdMutation>;
export type UpdateBookingByIdMutationResult = Apollo.MutationResult<UpdateBookingByIdMutation>;
export type UpdateBookingByIdMutationOptions = Apollo.BaseMutationOptions<UpdateBookingByIdMutation, UpdateBookingByIdMutationVariables>;
export const UpdateBookingPricesDocument = gql`
    mutation UpdateBookingPrices($_bookingId: Int!, $_prices: JSON!) {
  fUpdateTierPrices(input: {_bookingId: $_bookingId, _prices: $_prices}) {
    clientMutationId
  }
}
    `;
export type UpdateBookingPricesMutationFn = Apollo.MutationFunction<UpdateBookingPricesMutation, UpdateBookingPricesMutationVariables>;
export function useUpdateBookingPricesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingPricesMutation, UpdateBookingPricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingPricesMutation, UpdateBookingPricesMutationVariables>(UpdateBookingPricesDocument, options);
      }
export type UpdateBookingPricesMutationHookResult = ReturnType<typeof useUpdateBookingPricesMutation>;
export type UpdateBookingPricesMutationResult = Apollo.MutationResult<UpdateBookingPricesMutation>;
export type UpdateBookingPricesMutationOptions = Apollo.BaseMutationOptions<UpdateBookingPricesMutation, UpdateBookingPricesMutationVariables>;
export const UpdatePortByIdDocument = gql`
    mutation UpdatePortById($id: Int!, $name: String!, $countryId: Int) {
  updatePortById(
    input: {portPatch: {countryId: $countryId, name: $name}, id: $id}
  ) {
    clientMutationId
  }
}
    `;
export type UpdatePortByIdMutationFn = Apollo.MutationFunction<UpdatePortByIdMutation, UpdatePortByIdMutationVariables>;
export function useUpdatePortByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortByIdMutation, UpdatePortByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortByIdMutation, UpdatePortByIdMutationVariables>(UpdatePortByIdDocument, options);
      }
export type UpdatePortByIdMutationHookResult = ReturnType<typeof useUpdatePortByIdMutation>;
export type UpdatePortByIdMutationResult = Apollo.MutationResult<UpdatePortByIdMutation>;
export type UpdatePortByIdMutationOptions = Apollo.BaseMutationOptions<UpdatePortByIdMutation, UpdatePortByIdMutationVariables>;
export const UpdateRouteByIdDocument = gql`
    mutation UpdateRouteById($id: Int!, $code: String, $type: TradeDirection, $description: String) {
  updateRouteById(
    input: {id: $id, routePatch: {code: $code, type: $type, description: $description}}
  ) {
    clientMutationId
    route {
      id
      code
      type
      description
    }
  }
}
    `;
export type UpdateRouteByIdMutationFn = Apollo.MutationFunction<UpdateRouteByIdMutation, UpdateRouteByIdMutationVariables>;
export function useUpdateRouteByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteByIdMutation, UpdateRouteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteByIdMutation, UpdateRouteByIdMutationVariables>(UpdateRouteByIdDocument, options);
      }
export type UpdateRouteByIdMutationHookResult = ReturnType<typeof useUpdateRouteByIdMutation>;
export type UpdateRouteByIdMutationResult = Apollo.MutationResult<UpdateRouteByIdMutation>;
export type UpdateRouteByIdMutationOptions = Apollo.BaseMutationOptions<UpdateRouteByIdMutation, UpdateRouteByIdMutationVariables>;
export const UpdateRoutePortsDocument = gql`
    mutation updateRoutePorts($_ports: JSON, $_routeId: Int!) {
  fUpdateRoutePorts(input: {_ports: $_ports, _routeId: $_routeId}) {
    clientMutationId
  }
}
    `;
export type UpdateRoutePortsMutationFn = Apollo.MutationFunction<UpdateRoutePortsMutation, UpdateRoutePortsMutationVariables>;
export function useUpdateRoutePortsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoutePortsMutation, UpdateRoutePortsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoutePortsMutation, UpdateRoutePortsMutationVariables>(UpdateRoutePortsDocument, options);
      }
export type UpdateRoutePortsMutationHookResult = ReturnType<typeof useUpdateRoutePortsMutation>;
export type UpdateRoutePortsMutationResult = Apollo.MutationResult<UpdateRoutePortsMutation>;
export type UpdateRoutePortsMutationOptions = Apollo.BaseMutationOptions<UpdateRoutePortsMutation, UpdateRoutePortsMutationVariables>;
export const UpdateShippingCompanyByIdDocument = gql`
    mutation UpdateShippingCompanyById($id: Int!, $name: String!) {
  updateShipCompanyById(input: {id: $id, shipCompanyPatch: {name: $name}}) {
    clientMutationId
  }
}
    `;
export type UpdateShippingCompanyByIdMutationFn = Apollo.MutationFunction<UpdateShippingCompanyByIdMutation, UpdateShippingCompanyByIdMutationVariables>;
export function useUpdateShippingCompanyByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingCompanyByIdMutation, UpdateShippingCompanyByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingCompanyByIdMutation, UpdateShippingCompanyByIdMutationVariables>(UpdateShippingCompanyByIdDocument, options);
      }
export type UpdateShippingCompanyByIdMutationHookResult = ReturnType<typeof useUpdateShippingCompanyByIdMutation>;
export type UpdateShippingCompanyByIdMutationResult = Apollo.MutationResult<UpdateShippingCompanyByIdMutation>;
export type UpdateShippingCompanyByIdMutationOptions = Apollo.BaseMutationOptions<UpdateShippingCompanyByIdMutation, UpdateShippingCompanyByIdMutationVariables>;
export const UpdateTransportPriceByIdDocument = gql`
    mutation UpdateTransportPriceById($id: Int!, $truckCompanyId: Int, $suburbId: Int, $price: BigFloat, $containerType: ContainerSizeEnum, $unloadMethod: UnloadMethod, $validTo: Date) {
  updateTransportPriceById(
    input: {id: $id, transportPricePatch: {truckCompanyId: $truckCompanyId, suburbId: $suburbId, price: $price, containerType: $containerType, unloadMethod: $unloadMethod, validTo: $validTo}}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateTransportPriceByIdMutationFn = Apollo.MutationFunction<UpdateTransportPriceByIdMutation, UpdateTransportPriceByIdMutationVariables>;
export function useUpdateTransportPriceByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransportPriceByIdMutation, UpdateTransportPriceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransportPriceByIdMutation, UpdateTransportPriceByIdMutationVariables>(UpdateTransportPriceByIdDocument, options);
      }
export type UpdateTransportPriceByIdMutationHookResult = ReturnType<typeof useUpdateTransportPriceByIdMutation>;
export type UpdateTransportPriceByIdMutationResult = Apollo.MutationResult<UpdateTransportPriceByIdMutation>;
export type UpdateTransportPriceByIdMutationOptions = Apollo.BaseMutationOptions<UpdateTransportPriceByIdMutation, UpdateTransportPriceByIdMutationVariables>;
export const UpdateTruckCompanyByIdDocument = gql`
    mutation UpdateTruckCompanyById($id: BigInt!, $name: String, $email: [String], $phone: String, $address: String, $note: String, $abn: String, $extraCharge: JSON) {
  updateTruckCompanyById(
    input: {id: $id, truckCompanyPatch: {name: $name, email: $email, phone: $phone, address: $address, note: $note, abn: $abn, extraCharge: $extraCharge}}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateTruckCompanyByIdMutationFn = Apollo.MutationFunction<UpdateTruckCompanyByIdMutation, UpdateTruckCompanyByIdMutationVariables>;
export function useUpdateTruckCompanyByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTruckCompanyByIdMutation, UpdateTruckCompanyByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTruckCompanyByIdMutation, UpdateTruckCompanyByIdMutationVariables>(UpdateTruckCompanyByIdDocument, options);
      }
export type UpdateTruckCompanyByIdMutationHookResult = ReturnType<typeof useUpdateTruckCompanyByIdMutation>;
export type UpdateTruckCompanyByIdMutationResult = Apollo.MutationResult<UpdateTruckCompanyByIdMutation>;
export type UpdateTruckCompanyByIdMutationOptions = Apollo.BaseMutationOptions<UpdateTruckCompanyByIdMutation, UpdateTruckCompanyByIdMutationVariables>;
export const UpdateVesselByIdDocument = gql`
    mutation UpdateVesselById($id: Int!, $name: String!, $imo: Int, $mmsi: Int, $shipCompanyId: Int) {
  updateVesselById(
    input: {id: $id, vesselPatch: {name: $name, imo: $imo, mmsi: $mmsi, shipCompanyId: $shipCompanyId}}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateVesselByIdMutationFn = Apollo.MutationFunction<UpdateVesselByIdMutation, UpdateVesselByIdMutationVariables>;
export function useUpdateVesselByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVesselByIdMutation, UpdateVesselByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVesselByIdMutation, UpdateVesselByIdMutationVariables>(UpdateVesselByIdDocument, options);
      }
export type UpdateVesselByIdMutationHookResult = ReturnType<typeof useUpdateVesselByIdMutation>;
export type UpdateVesselByIdMutationResult = Apollo.MutationResult<UpdateVesselByIdMutation>;
export type UpdateVesselByIdMutationOptions = Apollo.BaseMutationOptions<UpdateVesselByIdMutation, UpdateVesselByIdMutationVariables>;
export const AgentByIdDocument = gql`
    query AgentById($id: Int!) {
  agentById(id: $id) {
    abn
    address
    countryByCountryId {
      name
      isoCode2
      isoCode3
    }
    email
    name
    phone
    bookingsByAgentId {
      nodes {
        id
        etd
        currency
        remark
        routeByRouteId {
          id
          code
          routeVesselsByRouteId {
            nodes {
              vesselByVesselId {
                id
                name
                shipCompanyByShipCompanyId {
                  id
                  name
                }
              }
            }
          }
        }
        portByPod {
          id
          name
        }
        portByPol {
          id
          name
        }
        bookingPricesByBookingId {
          nodes {
            containerSize
            cost
            id
          }
        }
      }
    }
  }
}
    `;
export function useAgentByIdQuery(baseOptions: Apollo.QueryHookOptions<AgentByIdQuery, AgentByIdQueryVariables> & ({ variables: AgentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentByIdQuery, AgentByIdQueryVariables>(AgentByIdDocument, options);
      }
export function useAgentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentByIdQuery, AgentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentByIdQuery, AgentByIdQueryVariables>(AgentByIdDocument, options);
        }
export function useAgentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentByIdQuery, AgentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentByIdQuery, AgentByIdQueryVariables>(AgentByIdDocument, options);
        }
export type AgentByIdQueryHookResult = ReturnType<typeof useAgentByIdQuery>;
export type AgentByIdLazyQueryHookResult = ReturnType<typeof useAgentByIdLazyQuery>;
export type AgentByIdSuspenseQueryHookResult = ReturnType<typeof useAgentByIdSuspenseQuery>;
export type AgentByIdQueryResult = Apollo.QueryResult<AgentByIdQuery, AgentByIdQueryVariables>;
export const AllAgentsDocument = gql`
    query AllAgents {
  allAgents {
    nodes {
      id
      name
      address
      phone
      abn
      email
      countryByCountryId {
        id
        name
      }
    }
  }
}
    `;
export function useAllAgentsQuery(baseOptions?: Apollo.QueryHookOptions<AllAgentsQuery, AllAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAgentsQuery, AllAgentsQueryVariables>(AllAgentsDocument, options);
      }
export function useAllAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAgentsQuery, AllAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAgentsQuery, AllAgentsQueryVariables>(AllAgentsDocument, options);
        }
export function useAllAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAgentsQuery, AllAgentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAgentsQuery, AllAgentsQueryVariables>(AllAgentsDocument, options);
        }
export type AllAgentsQueryHookResult = ReturnType<typeof useAllAgentsQuery>;
export type AllAgentsLazyQueryHookResult = ReturnType<typeof useAllAgentsLazyQuery>;
export type AllAgentsSuspenseQueryHookResult = ReturnType<typeof useAllAgentsSuspenseQuery>;
export type AllAgentsQueryResult = Apollo.QueryResult<AllAgentsQuery, AllAgentsQueryVariables>;
export const AllBookingPricesDocument = gql`
    query AllBookingPrices($minEtd: Date!) {
  allBookingPrices(
    filter: {bookingByBookingId: {etd: {greaterThanOrEqualTo: $minEtd}}}
  ) {
    nodes {
      containerSize
      cost
      id
      bookingByBookingId {
        agentByAgentId {
          id
          name
        }
        etd
        currency
        remark
        routeByRouteId {
          id
          code
          routeVesselsByRouteId {
            nodes {
              vesselByVesselId {
                id
                name
                shipCompanyByShipCompanyId {
                  id
                  name
                }
              }
            }
          }
        }
        portByPol {
          id
          name
        }
        portByDischargePort {
          id
          name
        }
        portByPod {
          id
          name
        }
      }
    }
  }
}
    `;
export function useAllBookingPricesQuery(baseOptions: Apollo.QueryHookOptions<AllBookingPricesQuery, AllBookingPricesQueryVariables> & ({ variables: AllBookingPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBookingPricesQuery, AllBookingPricesQueryVariables>(AllBookingPricesDocument, options);
      }
export function useAllBookingPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBookingPricesQuery, AllBookingPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBookingPricesQuery, AllBookingPricesQueryVariables>(AllBookingPricesDocument, options);
        }
export function useAllBookingPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllBookingPricesQuery, AllBookingPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllBookingPricesQuery, AllBookingPricesQueryVariables>(AllBookingPricesDocument, options);
        }
export type AllBookingPricesQueryHookResult = ReturnType<typeof useAllBookingPricesQuery>;
export type AllBookingPricesLazyQueryHookResult = ReturnType<typeof useAllBookingPricesLazyQuery>;
export type AllBookingPricesSuspenseQueryHookResult = ReturnType<typeof useAllBookingPricesSuspenseQuery>;
export type AllBookingPricesQueryResult = Apollo.QueryResult<AllBookingPricesQuery, AllBookingPricesQueryVariables>;
export const AllBookingsDocument = gql`
    query AllBookings($agentId: Int) {
  allBookings(condition: {agentId: $agentId}) {
    nodes {
      id
      etd
      remark
      currency
      routeId
      agentByAgentId {
        ...AgentFragment
      }
      routeByRouteId {
        id
        code
        routeVesselsByRouteId {
          nodes {
            vesselByVesselId {
              id
              name
              shipCompanyByShipCompanyId {
                id
                name
              }
            }
          }
        }
      }
      portByPod {
        id
        name
      }
      portByPol {
        id
        name
      }
      portByDischargePort {
        id
        name
      }
      bookingPricesByBookingId {
        nodes {
          ...BookingPriceFragment
        }
      }
    }
  }
}
    ${AgentFragmentFragmentDoc}
${BookingPriceFragmentFragmentDoc}`;
export function useAllBookingsQuery(baseOptions?: Apollo.QueryHookOptions<AllBookingsQuery, AllBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBookingsQuery, AllBookingsQueryVariables>(AllBookingsDocument, options);
      }
export function useAllBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBookingsQuery, AllBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBookingsQuery, AllBookingsQueryVariables>(AllBookingsDocument, options);
        }
export function useAllBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllBookingsQuery, AllBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllBookingsQuery, AllBookingsQueryVariables>(AllBookingsDocument, options);
        }
export type AllBookingsQueryHookResult = ReturnType<typeof useAllBookingsQuery>;
export type AllBookingsLazyQueryHookResult = ReturnType<typeof useAllBookingsLazyQuery>;
export type AllBookingsSuspenseQueryHookResult = ReturnType<typeof useAllBookingsSuspenseQuery>;
export type AllBookingsQueryResult = Apollo.QueryResult<AllBookingsQuery, AllBookingsQueryVariables>;
export const AllCountriesDocument = gql`
    query AllCountries {
  allCountries {
    nodes {
      name
      isoCode3
      isoCode2
      id
      currencyCode
      capital
      numericCode
      phoneCode
      region
      subregion
    }
    totalCount
  }
}
    `;
export function useAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, options);
      }
export function useAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, options);
        }
export function useAllCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, options);
        }
export type AllCountriesQueryHookResult = ReturnType<typeof useAllCountriesQuery>;
export type AllCountriesLazyQueryHookResult = ReturnType<typeof useAllCountriesLazyQuery>;
export type AllCountriesSuspenseQueryHookResult = ReturnType<typeof useAllCountriesSuspenseQuery>;
export type AllCountriesQueryResult = Apollo.QueryResult<AllCountriesQuery, AllCountriesQueryVariables>;
export const AllParkPricesDocument = gql`
    query AllParkPrices($minValidTo: Date!) {
  allParkPrices(filter: {validTo: {greaterThanOrEqualTo: $minValidTo}}) {
    nodes {
      id
      price
      parkName
      validTo
      truckCompanyByCompanyId {
        id
        name
      }
      stateByStateId {
        code
        name
      }
    }
  }
}
    `;
export function useAllParkPricesQuery(baseOptions: Apollo.QueryHookOptions<AllParkPricesQuery, AllParkPricesQueryVariables> & ({ variables: AllParkPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllParkPricesQuery, AllParkPricesQueryVariables>(AllParkPricesDocument, options);
      }
export function useAllParkPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllParkPricesQuery, AllParkPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllParkPricesQuery, AllParkPricesQueryVariables>(AllParkPricesDocument, options);
        }
export function useAllParkPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllParkPricesQuery, AllParkPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllParkPricesQuery, AllParkPricesQueryVariables>(AllParkPricesDocument, options);
        }
export type AllParkPricesQueryHookResult = ReturnType<typeof useAllParkPricesQuery>;
export type AllParkPricesLazyQueryHookResult = ReturnType<typeof useAllParkPricesLazyQuery>;
export type AllParkPricesSuspenseQueryHookResult = ReturnType<typeof useAllParkPricesSuspenseQuery>;
export type AllParkPricesQueryResult = Apollo.QueryResult<AllParkPricesQuery, AllParkPricesQueryVariables>;
export const AllPortsDocument = gql`
    query AllPorts {
  allPorts {
    nodes {
      id
      name
      countryId
    }
  }
}
    `;
export function useAllPortsQuery(baseOptions?: Apollo.QueryHookOptions<AllPortsQuery, AllPortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPortsQuery, AllPortsQueryVariables>(AllPortsDocument, options);
      }
export function useAllPortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPortsQuery, AllPortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPortsQuery, AllPortsQueryVariables>(AllPortsDocument, options);
        }
export function useAllPortsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPortsQuery, AllPortsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPortsQuery, AllPortsQueryVariables>(AllPortsDocument, options);
        }
export type AllPortsQueryHookResult = ReturnType<typeof useAllPortsQuery>;
export type AllPortsLazyQueryHookResult = ReturnType<typeof useAllPortsLazyQuery>;
export type AllPortsSuspenseQueryHookResult = ReturnType<typeof useAllPortsSuspenseQuery>;
export type AllPortsQueryResult = Apollo.QueryResult<AllPortsQuery, AllPortsQueryVariables>;
export const AllRouteVesselsDocument = gql`
    query AllRouteVessels {
  allRouteVessels {
    nodes {
      id
      routeByRouteId {
        code
        id
        routePortsByRouteId(orderBy: PORT_ORDER_ASC) {
          nodes {
            portByPortId {
              id
              name
            }
            portOrder
          }
        }
      }
      vesselByVesselId {
        id
        name
        shipCompanyByShipCompanyId {
          name
          id
        }
      }
    }
  }
}
    `;
export function useAllRouteVesselsQuery(baseOptions?: Apollo.QueryHookOptions<AllRouteVesselsQuery, AllRouteVesselsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRouteVesselsQuery, AllRouteVesselsQueryVariables>(AllRouteVesselsDocument, options);
      }
export function useAllRouteVesselsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRouteVesselsQuery, AllRouteVesselsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRouteVesselsQuery, AllRouteVesselsQueryVariables>(AllRouteVesselsDocument, options);
        }
export function useAllRouteVesselsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllRouteVesselsQuery, AllRouteVesselsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllRouteVesselsQuery, AllRouteVesselsQueryVariables>(AllRouteVesselsDocument, options);
        }
export type AllRouteVesselsQueryHookResult = ReturnType<typeof useAllRouteVesselsQuery>;
export type AllRouteVesselsLazyQueryHookResult = ReturnType<typeof useAllRouteVesselsLazyQuery>;
export type AllRouteVesselsSuspenseQueryHookResult = ReturnType<typeof useAllRouteVesselsSuspenseQuery>;
export type AllRouteVesselsQueryResult = Apollo.QueryResult<AllRouteVesselsQuery, AllRouteVesselsQueryVariables>;
export const AllRoutesDocument = gql`
    query AllRoutes {
  allRoutes {
    nodes {
      ...RouteFragment
    }
  }
}
    ${RouteFragmentFragmentDoc}`;
export function useAllRoutesQuery(baseOptions?: Apollo.QueryHookOptions<AllRoutesQuery, AllRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRoutesQuery, AllRoutesQueryVariables>(AllRoutesDocument, options);
      }
export function useAllRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRoutesQuery, AllRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRoutesQuery, AllRoutesQueryVariables>(AllRoutesDocument, options);
        }
export function useAllRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllRoutesQuery, AllRoutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllRoutesQuery, AllRoutesQueryVariables>(AllRoutesDocument, options);
        }
export type AllRoutesQueryHookResult = ReturnType<typeof useAllRoutesQuery>;
export type AllRoutesLazyQueryHookResult = ReturnType<typeof useAllRoutesLazyQuery>;
export type AllRoutesSuspenseQueryHookResult = ReturnType<typeof useAllRoutesSuspenseQuery>;
export type AllRoutesQueryResult = Apollo.QueryResult<AllRoutesQuery, AllRoutesQueryVariables>;
export const AllShipCompaniesDocument = gql`
    query AllShipCompanies {
  allShipCompanies {
    nodes {
      id
      name
    }
  }
}
    `;
export function useAllShipCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<AllShipCompaniesQuery, AllShipCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllShipCompaniesQuery, AllShipCompaniesQueryVariables>(AllShipCompaniesDocument, options);
      }
export function useAllShipCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllShipCompaniesQuery, AllShipCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllShipCompaniesQuery, AllShipCompaniesQueryVariables>(AllShipCompaniesDocument, options);
        }
export function useAllShipCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllShipCompaniesQuery, AllShipCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllShipCompaniesQuery, AllShipCompaniesQueryVariables>(AllShipCompaniesDocument, options);
        }
export type AllShipCompaniesQueryHookResult = ReturnType<typeof useAllShipCompaniesQuery>;
export type AllShipCompaniesLazyQueryHookResult = ReturnType<typeof useAllShipCompaniesLazyQuery>;
export type AllShipCompaniesSuspenseQueryHookResult = ReturnType<typeof useAllShipCompaniesSuspenseQuery>;
export type AllShipCompaniesQueryResult = Apollo.QueryResult<AllShipCompaniesQuery, AllShipCompaniesQueryVariables>;
export const AllStatesDocument = gql`
    query AllStates {
  allStates {
    nodes {
      code
      name
    }
  }
}
    `;
export function useAllStatesQuery(baseOptions?: Apollo.QueryHookOptions<AllStatesQuery, AllStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStatesQuery, AllStatesQueryVariables>(AllStatesDocument, options);
      }
export function useAllStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStatesQuery, AllStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStatesQuery, AllStatesQueryVariables>(AllStatesDocument, options);
        }
export function useAllStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStatesQuery, AllStatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStatesQuery, AllStatesQueryVariables>(AllStatesDocument, options);
        }
export type AllStatesQueryHookResult = ReturnType<typeof useAllStatesQuery>;
export type AllStatesLazyQueryHookResult = ReturnType<typeof useAllStatesLazyQuery>;
export type AllStatesSuspenseQueryHookResult = ReturnType<typeof useAllStatesSuspenseQuery>;
export type AllStatesQueryResult = Apollo.QueryResult<AllStatesQuery, AllStatesQueryVariables>;
export const AllSuburbsDocument = gql`
    query AllSuburbs {
  allSuburbs {
    nodes {
      id
      name
      postcode
      stateCode
    }
  }
}
    `;
export function useAllSuburbsQuery(baseOptions?: Apollo.QueryHookOptions<AllSuburbsQuery, AllSuburbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSuburbsQuery, AllSuburbsQueryVariables>(AllSuburbsDocument, options);
      }
export function useAllSuburbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSuburbsQuery, AllSuburbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSuburbsQuery, AllSuburbsQueryVariables>(AllSuburbsDocument, options);
        }
export function useAllSuburbsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSuburbsQuery, AllSuburbsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSuburbsQuery, AllSuburbsQueryVariables>(AllSuburbsDocument, options);
        }
export type AllSuburbsQueryHookResult = ReturnType<typeof useAllSuburbsQuery>;
export type AllSuburbsLazyQueryHookResult = ReturnType<typeof useAllSuburbsLazyQuery>;
export type AllSuburbsSuspenseQueryHookResult = ReturnType<typeof useAllSuburbsSuspenseQuery>;
export type AllSuburbsQueryResult = Apollo.QueryResult<AllSuburbsQuery, AllSuburbsQueryVariables>;
export const AllTransportPricesDocument = gql`
    query AllTransportPrices($minValidTo: Date!) {
  allTransportPrices(filter: {validTo: {greaterThanOrEqualTo: $minValidTo}}) {
    nodes {
      id
      price
      containerType
      unloadMethod
      validTo
      truckCompanyByTruckCompanyId {
        id
        name
      }
      suburbBySuburbId {
        id
        name
        postcode
        stateCode
      }
    }
  }
}
    `;
export function useAllTransportPricesQuery(baseOptions: Apollo.QueryHookOptions<AllTransportPricesQuery, AllTransportPricesQueryVariables> & ({ variables: AllTransportPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTransportPricesQuery, AllTransportPricesQueryVariables>(AllTransportPricesDocument, options);
      }
export function useAllTransportPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTransportPricesQuery, AllTransportPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTransportPricesQuery, AllTransportPricesQueryVariables>(AllTransportPricesDocument, options);
        }
export function useAllTransportPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTransportPricesQuery, AllTransportPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTransportPricesQuery, AllTransportPricesQueryVariables>(AllTransportPricesDocument, options);
        }
export type AllTransportPricesQueryHookResult = ReturnType<typeof useAllTransportPricesQuery>;
export type AllTransportPricesLazyQueryHookResult = ReturnType<typeof useAllTransportPricesLazyQuery>;
export type AllTransportPricesSuspenseQueryHookResult = ReturnType<typeof useAllTransportPricesSuspenseQuery>;
export type AllTransportPricesQueryResult = Apollo.QueryResult<AllTransportPricesQuery, AllTransportPricesQueryVariables>;
export const AllTruckCompaniesDocument = gql`
    query AllTruckCompanies {
  allTruckCompanies {
    nodes {
      id
      name
      email
      phone
      address
      note
      abn
    }
  }
}
    `;
export function useAllTruckCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<AllTruckCompaniesQuery, AllTruckCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTruckCompaniesQuery, AllTruckCompaniesQueryVariables>(AllTruckCompaniesDocument, options);
      }
export function useAllTruckCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTruckCompaniesQuery, AllTruckCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTruckCompaniesQuery, AllTruckCompaniesQueryVariables>(AllTruckCompaniesDocument, options);
        }
export function useAllTruckCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTruckCompaniesQuery, AllTruckCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTruckCompaniesQuery, AllTruckCompaniesQueryVariables>(AllTruckCompaniesDocument, options);
        }
export type AllTruckCompaniesQueryHookResult = ReturnType<typeof useAllTruckCompaniesQuery>;
export type AllTruckCompaniesLazyQueryHookResult = ReturnType<typeof useAllTruckCompaniesLazyQuery>;
export type AllTruckCompaniesSuspenseQueryHookResult = ReturnType<typeof useAllTruckCompaniesSuspenseQuery>;
export type AllTruckCompaniesQueryResult = Apollo.QueryResult<AllTruckCompaniesQuery, AllTruckCompaniesQueryVariables>;
export const AllVesselsDocument = gql`
    query AllVessels {
  allVessels {
    nodes {
      name
      mmsi
      imo
      id
      routeVesselsByVesselId {
        nodes {
          routeByRouteId {
            id
            code
          }
        }
      }
      shipCompanyByShipCompanyId {
        id
        name
      }
    }
  }
}
    `;
export function useAllVesselsQuery(baseOptions?: Apollo.QueryHookOptions<AllVesselsQuery, AllVesselsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVesselsQuery, AllVesselsQueryVariables>(AllVesselsDocument, options);
      }
export function useAllVesselsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVesselsQuery, AllVesselsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVesselsQuery, AllVesselsQueryVariables>(AllVesselsDocument, options);
        }
export function useAllVesselsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllVesselsQuery, AllVesselsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllVesselsQuery, AllVesselsQueryVariables>(AllVesselsDocument, options);
        }
export type AllVesselsQueryHookResult = ReturnType<typeof useAllVesselsQuery>;
export type AllVesselsLazyQueryHookResult = ReturnType<typeof useAllVesselsLazyQuery>;
export type AllVesselsSuspenseQueryHookResult = ReturnType<typeof useAllVesselsSuspenseQuery>;
export type AllVesselsQueryResult = Apollo.QueryResult<AllVesselsQuery, AllVesselsQueryVariables>;
export const AllWharfPricesDocument = gql`
    query AllWharfPrices($maxValidFrom: Date!) {
  allWharfPrices(filter: {validFrom: {lessThanOrEqualTo: $maxValidFrom}}) {
    nodes {
      id
      price
      tradeDirection
      validFrom
      truckCompanyByTruckCompanyId {
        id
        name
      }
      stateByStateId {
        code
        name
      }
    }
  }
}
    `;
export function useAllWharfPricesQuery(baseOptions: Apollo.QueryHookOptions<AllWharfPricesQuery, AllWharfPricesQueryVariables> & ({ variables: AllWharfPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllWharfPricesQuery, AllWharfPricesQueryVariables>(AllWharfPricesDocument, options);
      }
export function useAllWharfPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWharfPricesQuery, AllWharfPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllWharfPricesQuery, AllWharfPricesQueryVariables>(AllWharfPricesDocument, options);
        }
export function useAllWharfPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWharfPricesQuery, AllWharfPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllWharfPricesQuery, AllWharfPricesQueryVariables>(AllWharfPricesDocument, options);
        }
export type AllWharfPricesQueryHookResult = ReturnType<typeof useAllWharfPricesQuery>;
export type AllWharfPricesLazyQueryHookResult = ReturnType<typeof useAllWharfPricesLazyQuery>;
export type AllWharfPricesSuspenseQueryHookResult = ReturnType<typeof useAllWharfPricesSuspenseQuery>;
export type AllWharfPricesQueryResult = Apollo.QueryResult<AllWharfPricesQuery, AllWharfPricesQueryVariables>;
export const FuelLeviesByTruckCompanyIdDocument = gql`
    query FuelLeviesByTruckCompanyId($truckCompanyId: BigInt!) {
  allFuelLevies(condition: {truckCompanyId: $truckCompanyId}) {
    nodes {
      id
      levy
      validFrom
      validTo
    }
  }
}
    `;
export function useFuelLeviesByTruckCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<FuelLeviesByTruckCompanyIdQuery, FuelLeviesByTruckCompanyIdQueryVariables> & ({ variables: FuelLeviesByTruckCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FuelLeviesByTruckCompanyIdQuery, FuelLeviesByTruckCompanyIdQueryVariables>(FuelLeviesByTruckCompanyIdDocument, options);
      }
export function useFuelLeviesByTruckCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FuelLeviesByTruckCompanyIdQuery, FuelLeviesByTruckCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FuelLeviesByTruckCompanyIdQuery, FuelLeviesByTruckCompanyIdQueryVariables>(FuelLeviesByTruckCompanyIdDocument, options);
        }
export function useFuelLeviesByTruckCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FuelLeviesByTruckCompanyIdQuery, FuelLeviesByTruckCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FuelLeviesByTruckCompanyIdQuery, FuelLeviesByTruckCompanyIdQueryVariables>(FuelLeviesByTruckCompanyIdDocument, options);
        }
export type FuelLeviesByTruckCompanyIdQueryHookResult = ReturnType<typeof useFuelLeviesByTruckCompanyIdQuery>;
export type FuelLeviesByTruckCompanyIdLazyQueryHookResult = ReturnType<typeof useFuelLeviesByTruckCompanyIdLazyQuery>;
export type FuelLeviesByTruckCompanyIdSuspenseQueryHookResult = ReturnType<typeof useFuelLeviesByTruckCompanyIdSuspenseQuery>;
export type FuelLeviesByTruckCompanyIdQueryResult = Apollo.QueryResult<FuelLeviesByTruckCompanyIdQuery, FuelLeviesByTruckCompanyIdQueryVariables>;
export const PortByIdDocument = gql`
    query PortById($id: Int!) {
  portById(id: $id) {
    id
    name
    countryId
    routePortsByPortId {
      nodes {
        id
        portOrder
        date
        dow
        dateType
        routeByRouteId {
          id
          code
          description
          routeVesselsByRouteId {
            nodes {
              id
              vesselByVesselId {
                name
                id
                shipCompanyByShipCompanyId {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function usePortByIdQuery(baseOptions: Apollo.QueryHookOptions<PortByIdQuery, PortByIdQueryVariables> & ({ variables: PortByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortByIdQuery, PortByIdQueryVariables>(PortByIdDocument, options);
      }
export function usePortByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortByIdQuery, PortByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortByIdQuery, PortByIdQueryVariables>(PortByIdDocument, options);
        }
export function usePortByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortByIdQuery, PortByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortByIdQuery, PortByIdQueryVariables>(PortByIdDocument, options);
        }
export type PortByIdQueryHookResult = ReturnType<typeof usePortByIdQuery>;
export type PortByIdLazyQueryHookResult = ReturnType<typeof usePortByIdLazyQuery>;
export type PortByIdSuspenseQueryHookResult = ReturnType<typeof usePortByIdSuspenseQuery>;
export type PortByIdQueryResult = Apollo.QueryResult<PortByIdQuery, PortByIdQueryVariables>;
export const RouteByIdDocument = gql`
    query RouteById($id: Int!) {
  routeById(id: $id) {
    ...RouteFragment
    routeVesselsByRouteId {
      nodes {
        id
        vesselByVesselId {
          id
          name
          imo
          shipCompanyByShipCompanyId {
            id
            name
          }
        }
      }
    }
  }
}
    ${RouteFragmentFragmentDoc}`;
export function useRouteByIdQuery(baseOptions: Apollo.QueryHookOptions<RouteByIdQuery, RouteByIdQueryVariables> & ({ variables: RouteByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RouteByIdQuery, RouteByIdQueryVariables>(RouteByIdDocument, options);
      }
export function useRouteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RouteByIdQuery, RouteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RouteByIdQuery, RouteByIdQueryVariables>(RouteByIdDocument, options);
        }
export function useRouteByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RouteByIdQuery, RouteByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RouteByIdQuery, RouteByIdQueryVariables>(RouteByIdDocument, options);
        }
export type RouteByIdQueryHookResult = ReturnType<typeof useRouteByIdQuery>;
export type RouteByIdLazyQueryHookResult = ReturnType<typeof useRouteByIdLazyQuery>;
export type RouteByIdSuspenseQueryHookResult = ReturnType<typeof useRouteByIdSuspenseQuery>;
export type RouteByIdQueryResult = Apollo.QueryResult<RouteByIdQuery, RouteByIdQueryVariables>;
export const ShipCompanyByIdDocument = gql`
    query ShipCompanyById($id: Int!) {
  shipCompanyById(id: $id) {
    id
    name
    vesselsByShipCompanyId {
      nodes {
        id
        imo
        name
        routeVesselsByVesselId {
          nodes {
            routeByRouteId {
              code
              id
              routePortsByRouteId {
                nodes {
                  portByPortId {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function useShipCompanyByIdQuery(baseOptions: Apollo.QueryHookOptions<ShipCompanyByIdQuery, ShipCompanyByIdQueryVariables> & ({ variables: ShipCompanyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipCompanyByIdQuery, ShipCompanyByIdQueryVariables>(ShipCompanyByIdDocument, options);
      }
export function useShipCompanyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipCompanyByIdQuery, ShipCompanyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipCompanyByIdQuery, ShipCompanyByIdQueryVariables>(ShipCompanyByIdDocument, options);
        }
export function useShipCompanyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShipCompanyByIdQuery, ShipCompanyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShipCompanyByIdQuery, ShipCompanyByIdQueryVariables>(ShipCompanyByIdDocument, options);
        }
export type ShipCompanyByIdQueryHookResult = ReturnType<typeof useShipCompanyByIdQuery>;
export type ShipCompanyByIdLazyQueryHookResult = ReturnType<typeof useShipCompanyByIdLazyQuery>;
export type ShipCompanyByIdSuspenseQueryHookResult = ReturnType<typeof useShipCompanyByIdSuspenseQuery>;
export type ShipCompanyByIdQueryResult = Apollo.QueryResult<ShipCompanyByIdQuery, ShipCompanyByIdQueryVariables>;
export const TruckCompanyByIdDocument = gql`
    query TruckCompanyById($id: BigInt!) {
  truckCompanyById(id: $id) {
    id
    name
    email
    phone
    address
    note
    abn
    extraCharge
    transportPricesByTruckCompanyId {
      nodes {
        id
        price
        containerType
        unloadMethod
        validTo
        suburbBySuburbId {
          id
          name
          postcode
          stateCode
        }
      }
    }
    wharfPricesByTruckCompanyId {
      nodes {
        id
        price
        tradeDirection
        validFrom
        wharfName
        stateByStateId {
          code
          name
        }
        truckCompanyByTruckCompanyId {
          id
          name
        }
      }
    }
    parkPricesByCompanyId {
      nodes {
        id
        price
        parkName
        validTo
        stateByStateId {
          code
          name
        }
      }
    }
    tollFeesByCompanyId {
      nodes {
        id
        fee
        stateId
        validFrom
        validTo
        stateByStateId {
          code
          name
        }
      }
    }
  }
}
    `;
export function useTruckCompanyByIdQuery(baseOptions: Apollo.QueryHookOptions<TruckCompanyByIdQuery, TruckCompanyByIdQueryVariables> & ({ variables: TruckCompanyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TruckCompanyByIdQuery, TruckCompanyByIdQueryVariables>(TruckCompanyByIdDocument, options);
      }
export function useTruckCompanyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TruckCompanyByIdQuery, TruckCompanyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TruckCompanyByIdQuery, TruckCompanyByIdQueryVariables>(TruckCompanyByIdDocument, options);
        }
export function useTruckCompanyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TruckCompanyByIdQuery, TruckCompanyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TruckCompanyByIdQuery, TruckCompanyByIdQueryVariables>(TruckCompanyByIdDocument, options);
        }
export type TruckCompanyByIdQueryHookResult = ReturnType<typeof useTruckCompanyByIdQuery>;
export type TruckCompanyByIdLazyQueryHookResult = ReturnType<typeof useTruckCompanyByIdLazyQuery>;
export type TruckCompanyByIdSuspenseQueryHookResult = ReturnType<typeof useTruckCompanyByIdSuspenseQuery>;
export type TruckCompanyByIdQueryResult = Apollo.QueryResult<TruckCompanyByIdQuery, TruckCompanyByIdQueryVariables>;
export const VesselByIdDocument = gql`
    query VesselById($id: Int!) {
  vesselById(id: $id) {
    id
    name
    imo
    mmsi
    shipCompanyId
    shipCompanyByShipCompanyId {
      id
      name
    }
  }
}
    `;
export function useVesselByIdQuery(baseOptions: Apollo.QueryHookOptions<VesselByIdQuery, VesselByIdQueryVariables> & ({ variables: VesselByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VesselByIdQuery, VesselByIdQueryVariables>(VesselByIdDocument, options);
      }
export function useVesselByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VesselByIdQuery, VesselByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VesselByIdQuery, VesselByIdQueryVariables>(VesselByIdDocument, options);
        }
export function useVesselByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VesselByIdQuery, VesselByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VesselByIdQuery, VesselByIdQueryVariables>(VesselByIdDocument, options);
        }
export type VesselByIdQueryHookResult = ReturnType<typeof useVesselByIdQuery>;
export type VesselByIdLazyQueryHookResult = ReturnType<typeof useVesselByIdLazyQuery>;
export type VesselByIdSuspenseQueryHookResult = ReturnType<typeof useVesselByIdSuspenseQuery>;
export type VesselByIdQueryResult = Apollo.QueryResult<VesselByIdQuery, VesselByIdQueryVariables>;